import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IAddress } from 'app/shared/Domains/address';
import { IBranch } from 'app/shared/Domains/branch';
import { ICompany } from 'app/shared/Domains/company';
import { Customerstrainer } from 'app/shared/Domains/Customerstrainer';
import { IMemberFeeDetails } from 'app/shared/Domains/feeDetail';
import { IMember } from 'app/shared/Domains/member';
import { IMemberContact } from 'app/shared/Domains/memberContact';
import { IMemberEmergencyContact } from 'app/shared/Domains/memberEmergencyContact';
import { IMemberFreezeDetail } from 'app/shared/Domains/memberFreezeDetail';
import { IRole } from 'app/shared/Domains/role';
import { ISettings } from 'app/shared/Domains/settings';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { Configuration } from 'config/config';
import { AppUtils } from 'common/services/app.util';
import { formatApiErrorDetail } from 'common/services/api-error.util';
import { buildMemberUpdatePayload, customerUpdateUrl, walletCheckBalanceUrl, asDateString } from 'common/services/member-update-payload.util';
import {
    applyTaxSettingsToRow,
    calculateSplitGrandTotal,
    calculateSplitRowTotal,
    convertNetSplitsToGross,
    createEmptySplitRow,
    getSplitAllocationTarget,
    getSplitLineAmountPaid,
    isSplitAllocationValid,
    needsReceiptUpload,
    netSplitPayToGross,
    proportionalLineDiscount,
    recalculateRowTax,
    sumSplitIncludedTax,
    sumSplitPays,
    sumSplitTax,
    PaymentSplitRow,
    parseSplitPaymentModeLines,
    getReceiptPaymentModeHeader,
    buildSplitSrbInvoiceLines,
    buildSplitFbrInvoiceLines,
} from 'common/services/split-payment.util';
import { fbrDiLogoAbsoluteUrl, fbrQrItems, fbrReceiptBlockHtml } from 'common/services/fbr-receipt.util';
import {
    applyDefaultFundMonthYear,
    buildMonthlyFeeReportPayload,
    buildPayFundSplitPayload,
    billingStatusUrl,
    buildBillingStatusPayload,
    monthlyFeeReportUrl,
    payFundSplitUrl,
    resolveFeePaidUntilRaw,
    parseLocalBillingDate,
    formatInvoiceBillingDate,
    formatFeeInvoicePeriodStart,
    resolveInvoicePeriodDates,
    resolveMonthlyFeeDueDatePreview,
    trainerMonthlyFeeReportUrl,
    trainerBillingStatusUrl,
    buildTrainerBillingStatusPayload,
    prorateBillingPackageFee,
    prorateFeeForShortenedEnd,
    inclusiveBillingDayCount,
    toBillingDateString,
} from 'common/services/customer-fees-payload.util';
import { IPackageBuider } from 'app/shared/Domains/packageBuilder';
import { IUser } from 'app/shared/Domains/IUser';
import moment from "moment";
import { BreadcrumbService } from "app/breadcrumb.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from "rxjs";
import { DataService } from "app/shared/data.service";
import { LanguageService } from 'app/LanguageService/Language.Service';
import { IBusinessRule } from 'app/shared/Domains/businessRule';
@Component({
    selector: "app-add-fee",
    host: { "(window:keyup)": "hotkeys($event)" },
    templateUrl: "./add-fee.component.html",
    styleUrls: ["./add-fee.component.css"],
})
export class AddFeeComponent implements OnInit {
    @Input() memberID: any;
    @Input() customerFees: any;
    @Output() closeFeeCollectionDialog = new EventEmitter<any>();
    @Input() trainerSharePercentage: number;
    @Input() gymSharePercentage: number;
    fund: IMemberFeeDetails;
    fundInvoice: IMemberFeeDetails;
    member: any;
    Math = Math;
    options: { label: string; value: string }[];
    months: { label: string; value: number }[];
    years: { label: string; value: number }[];
    trainerNotSelected: boolean;
    array: any[];
    printAllFeeTotal: any = {};
    difference: number;
    feealreadypaid: boolean;
    isFeeMessageVisible: boolean = true;
    loading: boolean = true;
    allowDialog: boolean;
    memeberSetting: boolean = true;
    feegreater: boolean;
    freezeMemberDetails: any[];
    feeDetailsSource: any;
    numOfMonths: number;
    company: ICompany;
    packages: IPackageBuider[] = [];
    currentPackage: IPackageBuider;
    role: IRole;
    otherGroupMembersList = [];
    otherSelectedGroupMembers = [];
    payOtherGroupMemberFee = [];
    membersWithSamePackage = [];
    selectedMembersWithSamePackage = [];
    branch: IBranch;
    user: IUser;
    updateMemberSettingFlag: boolean = false;
    isDialogVisible: boolean;
    packagesDropDown: any[] = [];
    currentUserData:any;
    feeTotal: number;
    feeTotalDiscount: number;
    showActiceFreezeBox: boolean = false;
    packageName: any;
    numberOfMembers: any;
    discountAmount: number = 0;
    packageRegistrationFee: any;
    showTrainerFeeError: boolean = false;
    showRegistrationFeeError: boolean = false;
    showMonthlyFeeError: boolean = false;
    paymentOptions: any;
    branchName: string;
    packageToShowName: IPackageBuider[];
    packageFee: any;
    memberTrainer: any;
    isOtherMemberSelected: boolean = false;
    openFeeDialog: any;
    index: number;
    registrationPaid = false;
    monthlyPaid = false;
    trainerPaid = false;
    paymentMode: string;
    selectedFileName: string;
    modifiedFileName: string;
    previousDueDate: Date;
    selectedFile: File;
    trainerSessions: any;
    confirmationBoxMessage: string;
    statusOptions: any[];
    trainerOptions: any[];
    businessRules:  IBusinessRule;
    fundCollectiveInvoice: IMemberFeeDetails[] = [];
    firstInvoice: string;
    dialogVisibility: boolean = false;
    taxType :string;
    taxRate: number = 0;
    calculatedTax: number;
    numberOfMemberFeeToBePaid = 1;
    savedFeesToBePrint = [];
    hideTaxInfo: boolean = false;
    totalFeePaid: number;
    isWalletAllowed: boolean;
    walletAmountPaid: boolean = false;
    walletAmountPaidChecked: boolean = false;
    walletAmountUsedInput: number = 0;
    billingPeriodLabel: string = '';
    billingEndDate: Date | null = null;
    originalBillingPeriodStart: Date | null = null;
    originalBillingPeriodEnd: Date | null = null;
    originalBillingPackageFee = 0;
    billingPeriodFeeCeiling = 0;
    private suppressBillingEndAdjust = false;
    feePaidUntilLabel: string = '';
    private feePaidWarningShown = false;
    amountDue: number = 0;
    payAdvance: boolean = false;
    canPayAdvance: boolean = false;
    payNewPeriod: boolean = false;
    canPayNewPeriod: boolean = false;
    payNewPeriodBlockedMessage: string = '';
    billingStatusLoading: boolean = false;
    invoicePeriodStart: Date | null = null;
    invoicePeriodEnd: Date | null = null;
    billingNetPackageFee = 0;
    billingAlreadyPaid = 0;
    trainerLockedFee = 0;
    trainerFullPackageFee = 0;
    trainerPeriodStartLabel = '';
    trainerBillingEndDate: Date | null = null;
    trainerOriginalPeriodStart: Date | null = null;
    trainerOriginalPeriodEnd: Date | null = null;
    trainerFeeBlocked = false;
    walletMessage: string = "Deduct from wallet";
    walletStatusClass: string = "";
    singleInvoicePrint = {
        phone: "",
        memberId:"",
        companyLogo: "",
        branchName: "",
        branchAddress: "",
        branchPhone: "",
        invoice: "",
        date: new Date(),
        day: "",
        month: 0,
        year: 0,
        dueDate: new Date(),
        billingPeriodStart: null as Date | null,
        billingPeriodEnd: null as Date | null,
        previousDueDate: null as Date | string | null,
        nextDueDate: null as Date | string | null,
        memberTagNumber: "",
        memberName: "",
        feeStatus: "",
        feeAmount: 0,
        balance:0,
        taxOnFee: 0,
        memberPackageId: "",
        discountOnFee: 0
    };
    multiMonthInvoicePrint = {
        phone: "",
        memberId:"",
        memberTagNumber: "",
        memberPackageId: "",
        memberName: "",
        companyLogo: "",
        branchName: "",
        branchAddress: "",
        branchPhone: "",
        invoice: "",
        date: new Date(),
        day: "",
        month: 0,
        year: 0,
        dueDate: new Date(),
        monthFees : []
    };
    responseCount = 0;
    isFeeSubmitting = false;
    payOtherMemberFeeType = "RELATED_MEMBER_SELECTED";
    invoiceData: any;
    durationType: string;
    noOfDays: any;
    noOfWeeks: any;
    invoiceMessage: any;
    srbInvoiceId: string;
    /** Split receipt: one SRB line per payment mode; single mode uses srbInvoiceId only. */
    srbInvoiceLines: string[] = [];
    fbrInvoiceId = '';
    /** Split receipt: one raw FBR invoice number per payment mode. */
    fbrInvoiceLines: string[] = [];

    /** Single-mode receipt: SRB / FBR ids returned on the saved fee. */
    private setTaxInvoiceIdsFromFee(fee: { SRBInvoiceID?: string; FBRInvoiceID?: string } | null | undefined): void {
        const srbId = String(fee?.SRBInvoiceID ?? '').trim();
        const fbrId = String(fee?.FBRInvoiceID ?? '').trim();
        this.srbInvoiceId = srbId;
        this.srbInvoiceLines = srbId ? [srbId] : [];
        this.fbrInvoiceId = fbrId;
        this.fbrInvoiceLines = fbrId ? [fbrId] : [];
    }
    isDiscountFormulaReverse: boolean;
    resetTotalFreezingDays:number = 0;
    // --- Split payment (Multiple Payment Modes) ---
    selectedFeePackageId: string = 'primary';
    feePackageOptions: any[] = [];
    multiplePaymentModesEnabled: boolean = false;
    paymentSplits: PaymentSplitRow[] = [];

    constructor(
        private LanguageService: LanguageService,
        private confirmationService: ConfirmationService,
        public config: Configuration,
        private messageService: MessageService,
        private route: ActivatedRoute,
        private router: Router,
        private datePipe: DatePipe,
        private breadcrumbService: BreadcrumbService,
        private appServiceManager: AppServiceManager,
        private dataService: DataService
    ) {
        // route.params.subscribe((params) => {
        //     if (this.memberID === undefined) {
        //         this.memberID = params["id"];
        //         if (params["openFeeDialog"])
        //             this.openFeeDialog = params["openFeeDialog"]
        //     } else if (this.memberID !== params["id"]) {
        //         this.memberID = params["id"];
        //         this.getCustomerByID();
        //     }
        //     if (params && params.defaulter == "true"
        //         || params && params.fee == "true") {
        //         this.index = 1;
        //     } else {
        //         this.index = 0;
        //     }
        // });
    }
    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("AddFeeComponent", label);
      }
    ngOnInit(): void {
        const currentUser = localStorage.getItem('currentUser');
        this.currentUserData = currentUser ? JSON.parse(currentUser) : null;
        this.member = new IMember();
        this.company = new ICompany();
        this.openFeeDialog="true";
        this.branch = new IBranch();
        this.user = AuthService.getLoggedInUser();
        this.role = AuthService.getLoggedInRole();
        if (!this.user || !this.role) {
            this.dialogVisibility = false;
            this.closeFeeCollectionDialog.emit();
            this.router.navigateByUrl('/login');
            return;
        }
        const roleName = this.role?.name;
        if (roleName === "Admin" || roleName === "Super Admin") {
            this.memeberSetting = false;
        } else {
            this.memeberSetting = true;
        }
        this.freezeMemberDetails = [];
        this.isDialogVisible = true;
        this.currentPackage = new IPackageBuider();
        this.member.contactDetail = new IMemberContact();
        this.member.emergencyContact = new IMemberEmergencyContact();
        this.member.freezeDetail = new IMemberFreezeDetail();
        this.member.emergencyContact.medicalDetail = "";
        this.member.contactDetail.address = new IAddress();
        this.member.settings = new ISettings();
        this.member.customerstrainer = new Customerstrainer();
        this.fund = new IMemberFeeDetails();
        this.fundInvoice = new IMemberFeeDetails();
        this.member.customerstrainer.totalFees = "0";
        this.array = new Array("1", "2");
        this.difference = 0;
        this.dialogVisibility =true;
        this.fund.pay = 0;
        this.packageFee = 0;
        this.discountAmount = 0;
        this.fund.discountAmount = 0;
        this.packageRegistrationFee = 0;
        this.fund.status = "Monthly Fee - Paid";
        this.feealreadypaid = false;
        this.feePaidWarningShown = false;
        this.paymentOptions = [
            { label: 'Cash - Reception', value: 'Cash-Reception' },
        ];
        this.paymentMode = "Cash-Reception";
        this.printAllFeeTotal = {
            totalRegistationFee: 0,
            totalDiscountFee: 0,
            totalTrainerFee: 0,
            totalMonthlyFee: 0,
            totalFineFee: 0,
            feeGrandTotal: 0,
        }
        this.feegreater = false;
        this.options = [
            { label: "Select Fee Type", value: null },
            { label: "Fine Fee", value: "Fine Fee - Paid" },
            { label: "Monthly Fee", value: "Monthly Fee - Paid" },
            { label: "Registration Fee", value: "Registration Fee - Paid" },
            { label: "Trainer Fee", value: "Trainer Fee - Paid" },
        ];
        this.fund.status = "Monthly Fee - Paid";
        this.statusOptions = [
            { label: "Select Fee Type", value: null },
            { label: "All", value: "All" },
            { label: "Fine Fee", value: "Fine Fee - Paid" },
            { label: "Monthly Fee", value: "Monthly Fee - Paid" },
            { label: "Registration Fee", value: "Registration Fee - Paid" },
            { label: "Trainer Fee", value: "Trainer Fee - Paid" },
        ];

        this.months = [
            { label: "Select Month", value: null },
            { label: "January", value: 1 },
            { label: "Febuary", value: 2 },
            { label: "March", value: 3 },
            { label: "April", value: 4 },
            { label: "May", value: 5 },
            { label: "June", value: 6 },
            { label: "July", value: 7 },
            { label: "August", value: 8 },
            { label: "September", value: 9 },
            { label: "October", value: 10 },
            { label: "November", value: 11 },
            { label: "December", value: 12 },
        ];
        this.years = [
            { label: "Select Year", value: null },
            { label: "2015", value: 2015 },
            { label: "2016", value: 2016 },
            { label: "2017", value: 2017 },
            { label: "2018", value: 2018 },
            { label: "2019", value: 2019 },
            { label: "2020", value: 2020 },
            { label: "2021", value: 2021 },
            { label: "2022", value: 2022 },
            { label: "2023", value: 2023 },
            { label: "2024", value: 2024 },
            { label: "2025", value: 2025 },
            { label: "2026", value: 2026 },
            { label: "2027", value: 2027 },
            { label: "2028", value: 2028 },
            { label: "2029", value: 2029 },
            { label: "2030", value: 2030 },
            { label: "2031", value: 2031 },
            { label: "2032", value: 2032 },
            { label: "2033", value: 2033 },
            { label: "2034", value: 2034 },
            { label: "2035", value: 2035 },
            { label: "2036", value: 2036 },
            { label: "2037", value: 2037 },
            { label: "2038", value: 2038 },
            { label: "2039", value: 2039 },
            { label: "2040", value: 2040 },
        ];
        this.trainerOptions = [{ label: "Select Trainer", value: null }];
        this.packagesDropDown = [{ label: "Select Package", value: null }];
        this.getPackages();
        this.getCompany();
        this.getBranch();
        this.getCustomerByID();
        if(this.customerFees == undefined){
            this.customerFees=[];
        }
    }

    hotkeys(_event: KeyboardEvent): void {
        // Host listener placeholder to satisfy the component host binding.
        // Keyboard shortcut flow is not implemented in this dialog.
    }
    getCompany() {
        this.company = AuthService.getLoggedInCompanyBranch();
        if(!this.company){
        this.appServiceManager.get("companies/current").subscribe(
            (res) => {
                if (res) {
                    this.company = res;
                } else {
                    this.company = new ICompany();
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "Something Went Wrong",
                    });
                }
            },
            (error) => {
                this.company = new ICompany();
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: formatApiErrorDetail(error),
                });
            }
        );
    }
    }

    getBranch() {
        this.branch = AuthService.getLoggedInCurrentBranch();
        if(this.branch){
            this.branchName = this.branch.name;
            this.invoiceData = this.branch.invoiceData;
            this.member.password = this.branch.appPassword;
            this.isWalletAllowed = this.branch.permissions?.isAllowWallet ?? false;
            this.isDiscountFormulaReverse = !!this.branch?.permissions?.isDiscountFormulaReverse;
            if (Array.isArray(this.branch.payments)) {
                this.branch.payments.forEach(payment => {
                    const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
                    if (!existingBank) {
                        this.paymentOptions.push({
                            label: `${payment.type} - ${payment.name}`,
                            value: `${payment.type}-${payment.name}`
                        });
                    }
                });
                let length;
                if (Array.isArray(this.branch.payments)) {
                    length = this.branch.payments.length;
                }
                this.taxType = this.branch.payments[length-1].taxSettings.taxCalculationType;
                this.taxRate = this.branch.payments[length-1].taxSettings.taxRate;
                const paymentModes = this.branch.payments.filter(x => x.taxSettings.taxCalculationType == "NO_TAX");
                if(paymentModes.length == this.branch.payments.length) {
                    this.hideTaxInfo = true;
                }
                if(this.branch.businessRule == true ){
                    this.getBusinessRules();
                }
            }
        }
        if(!this.branch && this.user?.branch){

            this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
              if (res) {
                this.branch = res;
                this.invoiceData = res.invoiceData;
                this.branchName = res.name;
                this.member.password = res.appPassword;
                this.isWalletAllowed = res.permissions?.isAllowWallet ?? false;
                this.isDiscountFormulaReverse = !!res.permissions?.isDiscountFormulaReverse;
                res.payments.forEach(payment => {
                    const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
                    if (!existingBank) {
                        this.paymentOptions.push({
                            label: `${payment.type} - ${payment.name}`,
                            value: `${payment.type}-${payment.name}`
                        });
                    }
                });
                let length;
                if (Array.isArray(this.branch.payments)) {
                    length = this.branch.payments.length;
                }
                this.taxType = this.branch.payments[length-1].taxSettings.taxCalculationType;
                this.taxRate = this.branch.payments[length-1].taxSettings.taxRate;
                const paymentModes = res.payments.filter(x => x.taxSettings.taxCalculationType == "NO_TAX");
                if(paymentModes.length == res.payments.length) {
                  this.hideTaxInfo = true;
                }
                if(this.branch.businessRule == true ){
                    this.getBusinessRules();
                }
              } else {
                this.branch = new IBranch();
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
              }
            },
              (error) => {
                this.branch = new IBranch();
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: formatApiErrorDetail(error) });
            });
        }
        this.invoiceMessage = this.branch.invoiceData?.invoiceMessage || '';
    }

    loadPackages() {
        this.getPackages();
        this.getPackagesByID();
    }

    async getCustomerByID() {
        try {
            const res: any = await this.appServiceManager
              .get("branches/" + this.user.branch + "/customers/" + this.memberID)
              .toPromise();

            if (res) {
                this.member = res;
                this.rebuildFeePackageOptions();
                this.feeDetailsSource = JSON.stringify(this.member.feeDetails);
                this.member.oldDate = this.member.settings.dueDate;
                this.member.oldValue = this.member.packageName;
                this.member.currentUserData = this.currentUserData;
                this.member.feeDetails = this.member.feeDetails.sort(this.compareByDate);

                this.validateMember(res);
                this.setDate(res);
                this.getTotalForAllReciptPrint();
                this.breadcrumbService.setItems([
                    { label: "Member Management" },
                    { label: "All Members", routerLink: "/members" },
                    { label: this.member.name },
                ]);
                this.getCompany();
                this.calculateTotal();
                if (res.customerstrainer?.name)
                    this.memberTrainer = res.customerstrainer.name;
                else
                    this.memberTrainer = "Not Assigned";
                if (this.openFeeDialog == "true") {
                    this.allowDialog = true;
                }
                await this.getPackagesByID();
                if (this.fund.status === 'Monthly Fee - Paid') {
                    await this.loadBillingStatus();
                }
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: "info",
                    summary: "Info Message",
                    detail: "Something Went Wrong",
                });
            }
        } catch (error) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: formatApiErrorDetail(error),
            });
        }
    }
    getBusinessRules() {
        this.appServiceManager
        .get("businessRules/branch/"  + this.branch._id).subscribe(
            (res: any) => {
              if (res.length > 0) {
                this.businessRules = res[0];
              } else {
                this.messageService.clear();
                this.messageService.add({
                  severity: "info",
                  summary: "Info Message",
                  detail: "No Record Found",
                });
              }
            },
            (error) => {
              this.messageService.clear();
              this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: formatApiErrorDetail(error),
              });
            }
          );
      }
    async getRelatedMembers() {
        this.otherGroupMembersList = [];
        const peopleWithSamePackage = this.member.relatedMember.filter(r => r.packageId == this.member.packageId);
        const preSelectedMembers = [];

        for (const element of peopleWithSamePackage) {
          const date = new Date();
          try {
            const feeRes = await this.appServiceManager.get('branches/' + AuthService.getLoggedInBranch() + '/customers/' + element.memberId + '/actions/check-member-fee-of-month/' + date.getFullYear() + '/' + (date.getMonth() + 1)).toPromise();
            if (feeRes.status && !feeRes.response) {
              const data = {
                name: element.name + " (" + element.tagNumber + ")",
                code: element.memberId
              };
              const exist = this.otherGroupMembersList.find(l => l.code === data.code);
              if (!exist) {
                this.otherGroupMembersList.push(data);
                preSelectedMembers.push(data); // Push the entire object to preSelectedMembers
              }
            }
          } catch (error) {
            console.error("Error fetching member fee status:", error);
          }
        }

        // Pre-select the related members if available
        if (preSelectedMembers.length > 0) {
          this.otherSelectedGroupMembers = [...preSelectedMembers]; // Ensure it is a new array of objects
          this.otherSelectedGroupMembers.forEach(member =>{
              this.otherSelectedGroupRelatedMembersChange(member, 'MEMBER_WITH_SAME_PACKAGE_SELECTED')
          })
          console.log("Preselected Members:", this.otherSelectedGroupMembers);
        } else {
          this.otherSelectedGroupMembers = [];
        }
      }

    async getRelatedMembersFromGroup() {
        this.otherGroupMembersList = [];
        this.otherSelectedGroupMembers = [];

        if (!this.member?.relatedMembersId) {
            return;
        }

        try {
            const res: any = await this.appServiceManager
                .get('branches/' + AuthService.getLoggedInBranch() + '/customers/actions/related-members-group/' + this.member.relatedMembersId)
                .toPromise();

            if (!res?.status || !res?.response?.members) {
                return;
            }

            const groupMembers = res.response.members.filter(
                (m: any) => m.memberId && m.memberId !== this.member._id
            );
            const preSelectedMembers = [];

            if (this.isSameHistoryActive()) {
                for (const element of groupMembers) {
                    const data = {
                        name: element.name + ' (' + element.tagNumber + ')',
                        code: element.memberId,
                    };
                    const exist = this.otherGroupMembersList.find((l) => l.code === data.code);
                    if (!exist) {
                        this.otherGroupMembersList.push(data);
                        preSelectedMembers.push(data);
                    }
                }
            } else {
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;

            for (const element of groupMembers) {
                try {
                    const feeRes: any = await this.appServiceManager
                        .get('branches/' + AuthService.getLoggedInBranch() + '/customers/' + element.memberId + '/actions/check-member-fee-of-month/' + year + '/' + month)
                        .toPromise();

                    if (feeRes?.status && !feeRes?.response) {
                        const data = {
                            name: element.name + " (" + element.tagNumber + ")",
                            code: element.memberId
                        };
                        const exist = this.otherGroupMembersList.find(l => l.code === data.code);
                        if (!exist) {
                            this.otherGroupMembersList.push(data);
                            preSelectedMembers.push(data);
                        }
                    }
                } catch (error) {
                    console.error("Error fetching member fee status:", error);
                }
            }
            }

            if (preSelectedMembers.length > 0) {
                this.otherSelectedGroupMembers = [...preSelectedMembers];
                this.otherSelectedGroupMembers.forEach(member => {
                    this.otherSelectedGroupRelatedMembersChange(member, 'MEMBER_WITH_SAME_PACKAGE_SELECTED');
                });
            }
        } catch (error) {
            console.error("Error fetching related members group:", error);
        }
    }


    getPackages() {
        this.packages = [];
        this.appServiceManager
            .get(
                "branches/" +
                this.user.branch +
                "/package-builders"
            )
            .subscribe(
                (res: IPackageBuider[]) => {
                    this.packages = res;
                    this.setPackages(res);
                    this.packageToShowName = res;
                    this.rebuildFeePackageOptions();
                },
                (error: any) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: formatApiErrorDetail(error),
                    });
                }
            );
    }

    setPackages(packages) {
        this.packagesDropDown = [{ label: "Select Package", value: null }];
        packages.map((data: any) => this.packagesDropDown.push({ label: data.packageName, value: data._id }));
    }

    otherSelectedGroupRelatedMembersChange(event, memberType) {
        this.payOtherMemberFeeType = memberType;

        if (event) {
            this.numberOfMemberFeeToBePaid += 1;

            const newMember = {
            code: event.code,
            name: event.name,
            memberType: memberType
            };

            // Concatenate without duplicates (optional check below)
            const alreadyExists = this.payOtherGroupMemberFee.some(m => m.code === newMember.code);
            if (!alreadyExists) {
            this.payOtherGroupMemberFee = this.payOtherGroupMemberFee.concat(newMember);
            }

            this.isOtherMemberSelected = true;
        } else {
            this.payOtherGroupMemberFee = [];
            this.numberOfMemberFeeToBePaid = 1;
            this.isOtherMemberSelected = false;
        }
        }

    otherSelectedGroupMembersChange(event, memberType) {
        this.payOtherMemberFeeType = memberType;
        if(event.value.length > 0) {
            this.numberOfMemberFeeToBePaid = 1 + event.value.length;
            this.payOtherGroupMemberFee = event.value;
            this.isOtherMemberSelected = true;
        }
        else {
            this.numberOfMemberFeeToBePaid = 1;
            this.isOtherMemberSelected = false;
        }
    }

    isDateDisabled(): boolean {
        return true;
    }

    onPaymentModeChange(value: string) {
        this.paymentMode = value;
        const extractedValue = value.split("-")[1];
        if (Array.isArray(this.branch.payments)) {
            this.branch.payments.forEach(payment => {
                if (payment.name == extractedValue) {
                    this.taxType=payment.taxSettings.taxCalculationType;
                    this.taxRate=payment.taxSettings.taxRate;
                }
            });
        }
        // Refresh tax/total immediately so After Discount Fee matches the new mode
        // (same path as discount change; previously only updated on discount tweak).
        this.validateDiscount();
    }

    // ------------------------------------------------------------------
    // Split payment (Multiple Payment Modes)
    // ------------------------------------------------------------------

    /** Packages may store the flag as boolean true or string "true". */
    isGroupFeePayByOnePerson(): boolean {
        const val = this.currentPackage?.groupFeePayByOnePerson as unknown;
        return val === true || val === 'true';
    }

    isSameHistoryActive(): boolean {
        const pkg = this.currentPackage;
        return !!(
            this.isGroupFeePayByOnePerson() &&
            (pkg?.noOfMembers ?? 0) > 1 &&
            (pkg?.sameHistory === true || (pkg?.sameHistory as unknown) === 'true')
        );
    }

    expectedSameHistoryGroupFeeCount(): number {
        return 1 + (this.otherGroupMembersList?.length ?? 0);
    }

    /** Toggle is always available except for group-pay-by-one packages and secondary fees. */
    showMultiplePaymentModesToggle(): boolean {
        return !this.isGroupFeePayByOnePerson() && !this.isSecondaryFeeSelected();
    }

    hasSecondaryPackages(): boolean {
        return !!(this.member?.secondaryPackages && this.member.secondaryPackages.length);
    }

    isSecondaryFeeSelected(): boolean {
        return this.selectedFeePackageId && this.selectedFeePackageId !== 'primary';
    }

    rebuildFeePackageOptions(): void {
        const primaryFee = this.currentPackage
            ? Math.round(Number(this.currentPackage.packageFee) || 0)
            : Math.round(Number(this.packageFee) || 0);
        const options = [
            {
                label: this.member?.packageName || this.setLabel('primaryPackageChipLabel'),
                value: 'primary',
                kind: 'primary',
                fee: primaryFee,
            },
        ];
        (this.member?.secondaryPackages || []).forEach((pkg) => {
            const found = (this.packages || []).find(
                (item) => String(item._id) === String(pkg.packageId),
            );
            options.push({
                label: pkg.packageName,
                value: String(pkg.packageId),
                kind: 'secondary',
                fee: found ? Math.round(Number(found.packageFee) || 0) : null,
            });
        });
        this.feePackageOptions = options;
    }

    onFeePackageChange(event?: { value?: string }) {
        if (event && event.value != null && event.value !== '') {
            this.selectedFeePackageId = String(event.value);
        }
        this.resetSplitState();
        this.payAdvance = false;
        this.payNewPeriod = false;
        this.canPayNewPeriod = false;
        this.payNewPeriodBlockedMessage = '';
        this.walletAmountPaid = false;
        this.walletAmountUsedInput = 0;
        this.otherSelectedGroupMembers = [];
        this.numberOfMemberFeeToBePaid = 1;
        if (this.isSecondaryFeeSelected()) {
            this.fund.status = 'Monthly Fee - Paid';
            this.canPayAdvance = false;
            this.feePaidUntilLabel = '';
            this.feealreadypaid = false;
            this.fund.isSecondaryPackageFee = true;
            this.fund.packageId = this.selectedFeePackageId;
            const assigned = (this.member?.secondaryPackages || []).find(
                (p) => String(p.packageId) === String(this.selectedFeePackageId),
            );
            this.fund.packageName = assigned ? assigned.packageName : '';
            const pkg = (this.packages || []).find(
                (p) => String(p._id) === String(this.selectedFeePackageId),
            );
            const feeAmount = pkg ? Math.round(Number(pkg.packageFee) || 0) : 0;
            this.packageFee = feeAmount;
            this.fund.pay = feeAmount;
            this.amountDue = feeAmount;
            this.difference = feeAmount;
            this.feegreater = false;
            this.discountAmount = 0;
            if (pkg) {
                this.numOfMonths = pkg.noOfMonths;
                this.noOfDays = pkg.noOfDays;
                this.noOfWeeks = pkg.noOfWeeks;
                this.durationType = pkg.durationType;
            }
            return;
        }
        this.fund.isSecondaryPackageFee = false;
        this.fund.packageId = this.member?.packageId;
        this.fund.packageName = this.member?.packageName;
        if (this.currentPackage) {
            this.packageFee = this.currentPackage.packageFee;
            this.numOfMonths = this.currentPackage.noOfMonths;
            this.noOfDays = this.currentPackage.noOfDays;
            this.noOfWeeks = this.currentPackage.noOfWeeks;
            this.durationType = this.currentPackage.durationType;
        }
        this.loadBillingStatus();
    }

    needsReceiptUpload(): boolean {
        return needsReceiptUpload(this.paymentMode);
    }

    onMultiplePaymentModesToggle(checked: boolean): void {
        this.multiplePaymentModesEnabled = checked;
        if (checked) {
            this.initPaymentSplits();
        } else {
            this.paymentSplits = [];
        }
    }

    /** Two empty rows (pay: null) — amounts are never pre-distributed. */
    initPaymentSplits(): void {
        const defaultMode = this.paymentOptions?.[0]?.value || '';
        const first = createEmptySplitRow(defaultMode);
        const second = createEmptySplitRow(defaultMode);
        if (defaultMode) {
            applyTaxSettingsToRow(first, this.branch?.payments, defaultMode);
            applyTaxSettingsToRow(second, this.branch?.payments, defaultMode);
        }
        this.paymentSplits = [first, second];
        this.recalculateAllSplitRows();
    }

    addPaymentSplitRow(): void {
        const defaultMode = this.paymentOptions?.[0]?.value || '';
        const row = createEmptySplitRow(defaultMode);
        if (defaultMode) {
            applyTaxSettingsToRow(row, this.branch?.payments, defaultMode);
        }
        this.paymentSplits = [...this.paymentSplits, row];
        this.recalculateAllSplitRows();
    }

    removePaymentSplitRow(rowId: string): void {
        if (this.paymentSplits.length <= 2) {
            return;
        }
        this.paymentSplits = this.paymentSplits.filter((r) => r.id !== rowId);
        this.recalculateAllSplitRows();
    }

    /** Mode change updates tax settings only — never fills the amount. */
    onSplitPaymentModeChange(row: PaymentSplitRow, mode: string): void {
        applyTaxSettingsToRow(row, this.branch?.payments, mode);
        this.recalculateAllSplitRows();
    }

    onSplitPayChange(row: PaymentSplitRow, value: number | string | null): void {
        if (value === '' || value === null || value === undefined) {
            row.pay = null;
        } else {
            row.pay = Math.round(Number(value) || 0);
        }
        this.recalculateAllSplitRows();
    }

    trackSplitRowById(_index: number, row: PaymentSplitRow): string {
        return row.id;
    }

    get allocatedSplitTotal(): number {
        return sumSplitPays(this.paymentSplits);
    }

    /** LOCKED: rows must sum to the collected pay (fund.pay − discount, or trainer cash). */
    get splitAllocationTarget(): number {
        if (this.isTrainerFee()) {
            return this.trainerCollectedPay();
        }
        return getSplitAllocationTarget(
            Number(this.fund?.pay) || 0,
            this.discountAmount || 0,
        );
    }

    get splitTotalTax(): number {
        return sumSplitTax(this.paymentSplits);
    }

    get splitTotalIncludedTax(): number {
        return sumSplitIncludedTax(this.paymentSplits);
    }

    get splitGrandTotal(): number {
        return calculateSplitGrandTotal(this.paymentSplits);
    }

    isSplitAllocationValid(): boolean {
        return isSplitAllocationValid(this.paymentSplits, this.splitAllocationTarget);
    }

    hasDuplicateSplitPaymentModes(): boolean {
        const seen = new Set<string>();
        for (const row of this.paymentSplits || []) {
            const mode = String(row?.paymentMode || '').trim();
            if (!mode) continue;
            if (seen.has(mode)) return true;
            seen.add(mode);
        }
        return false;
    }

    hasIncompleteSplitRows(): boolean {
        return (this.paymentSplits || []).some((row) => {
            const mode = String(row?.paymentMode || '').trim();
            const pay = Number(row?.pay);
            return !mode || !Number.isFinite(pay) || pay <= 0;
        });
    }

    isSplitFormValid(): boolean {
        return (
            this.multiplePaymentModesEnabled &&
            this.paymentSplits.length >= 2 &&
            !this.hasIncompleteSplitRows() &&
            !this.hasDuplicateSplitPaymentModes() &&
            this.isSplitAllocationValid()
        );
    }

    get splitValidationMessage(): string {
        if (!this.multiplePaymentModesEnabled) return '';
        if (this.hasIncompleteSplitRows()) {
            return this.setLabel('splitFillAllRowsErrorLabel');
        }
        if (this.hasDuplicateSplitPaymentModes()) {
            return this.setLabel('splitDuplicateModeErrorLabel');
        }
        if (!this.isSplitAllocationValid()) {
            return this.setLabel('splitAllocationMismatchErrorLabel');
        }
        return '';
    }

    shouldUseSplitPayment(): boolean {
        return !this.isSecondaryFeeSelected() && this.multiplePaymentModesEnabled && this.paymentSplits.length >= 2;
    }

    /**
     * Recalculate tax / discount share / line total for every row.
     * Rows hold NET amounts; tax rules run on the GROSS equivalent so they
     * mirror the single-mode formulas. Always reassigns the array so change
     * detection refreshes the table.
     */
    recalculateAllSplitRows(): void {
        if (!this.multiplePaymentModesEnabled) {
            return;
        }
        const isTrainer = this.isTrainerFee();
        const fundPay = isTrainer
            ? this.trainerGrossFee()
            : Number(this.fund?.pay) || 0;
        const fundDiscount = this.discountAmount || 0;
        const netTarget = isTrainer
            ? this.trainerCollectedPay()
            : getSplitAllocationTarget(fundPay, fundDiscount);
        this.paymentSplits = this.paymentSplits.map((row) => {
            const updated = { ...row };
            const grossPay = netSplitPayToGross(updated.pay, fundPay, netTarget);
            const lineDiscount = proportionalLineDiscount(grossPay, fundPay, fundDiscount);
            const taxRow: PaymentSplitRow = { ...updated, pay: grossPay };
            recalculateRowTax(taxRow, lineDiscount, {
                isDiscountFormulaReverse: this.isDiscountFormulaReverse,
                fundPay,
                fundDiscount,
            });
            updated.tax = taxRow.tax;
            updated.includedTax = taxRow.includedTax;
            updated.lineDiscount = lineDiscount;
            updated.lineTotal = calculateSplitRowTotal(taxRow, lineDiscount);
            return updated;
        });
    }

    /** Set fund aggregates from the split rows before submit. */
    syncSplitTotalsForSubmit(): void {
        this.fund.tax = Math.round(this.splitTotalTax || 0);
        this.calculatedTax = Math.round(this.splitTotalTax || 0);
        this.totalFeePaid = Math.round(this.splitGrandTotal || 0);
        this.fund.totalFeePaid = Math.round(this.splitGrandTotal || 0);
        this.fund.discount = Math.round(this.discountAmount || 0);
    }

    /** NET UI rows → GROSS API rows (sum(gross) === fund.pay). */
    buildSplitLinesForSubmit(): PaymentSplitRow[] {
        if (this.isTrainerFee()) {
            return convertNetSplitsToGross(
                this.paymentSplits.map((row) => ({ ...row })),
                this.trainerCollectedPay(),
                0,
            );
        }
        return convertNetSplitsToGross(
            this.paymentSplits.map((row) => ({ ...row })),
            Number(this.fund?.pay) || 0,
            this.discountAmount || 0,
        );
    }

    resetSplitState(): void {
        this.multiplePaymentModesEnabled = false;
        this.paymentSplits = [];
    }

  /** Mode-of-payment lines on receipt: net paid per method (after discount + tax). */
    buildSplitPaymentModeLabel(fees: any[]): string {
        if (this.paymentSplits?.length) {
            return this.paymentSplits
                .map((row) => {
                    const amount =
                        row.lineTotal != null
                            ? Number(row.lineTotal) || 0
                            : Number(row.pay) || 0;
                    return `${row.paymentMode || ''}: ${amount.toLocaleString()}`;
                })
                .join('<br>');
        }
        return (fees || [])
            .map((fee) => {
                const amount = getSplitLineAmountPaid(fee);
                return `${fee.paymentMode || ''}: ${amount.toLocaleString()}`;
            })
            .join('<br>');
    }

    /**
     * Print split payment using the same thermal receipt as single-mode add fee,
     * with both/all payment methods listed in the Mode of Payment row.
     */
    private async printSplitInvoiceUsingExistingTemplate(
        memberObj: any,
        fees: any[],
    ): Promise<void> {
        const savedTaxType = this.taxType;
        const totalTax = this.splitTotalTax;
        const totalIncludedTax = this.splitTotalIncludedTax;
        if (totalTax > 0) {
            this.taxType = 'WITH_TAX';
            this.fund.tax = totalTax;
        } else if (totalIncludedTax > 0) {
            this.taxType = 'INCLUDING_TAX';
            this.fund.tax = totalIncludedTax;
        } else {
            this.taxType = 'NO_TAX';
            this.fund.tax = 0;
        }

        this.fund.paymentMode = this.buildSplitPaymentModeLabel(fees);
        this.fund.discount = Math.round(this.discountAmount || 0);

        this.singleInvoicePrint.memberId = memberObj._id;
        this.singleInvoicePrint.phone = memberObj.contactDetail?.contact;
        this.singleInvoicePrint.companyLogo = this.company.bannerImage;
        this.singleInvoicePrint.branchName = this.branch.name;
        this.singleInvoicePrint.branchAddress = this.branch.address;
        this.singleInvoicePrint.branchPhone = this.branch.phone;
        // Base invoice on receipt (same as single fee) — DB rows keep -1 / -2 suffixes.
        this.singleInvoicePrint.invoice = this.fund.invoice;
        this.singleInvoicePrint.date = this.fund.date;
        this.singleInvoicePrint.day = this.fund.day;
        this.singleInvoicePrint.month = this.fund.month;
        this.singleInvoicePrint.year = this.fund.year;
        this.singleInvoicePrint.dueDate = this.fund.dueDate;
        this.stampInvoicePeriodOnPrint(this.singleInvoicePrint);
        if (this.branch.businessRule == true) {
            if (this.businessRules?.businessRule == 'FEEAPPROVALADMIN') {
                this.singleInvoicePrint.dueDate = this.fund.dueDateAfterApproval;
            }
        }
        this.singleInvoicePrint.memberTagNumber = memberObj.tagNumber;
        this.singleInvoicePrint.memberName = memberObj.name;
        this.singleInvoicePrint.memberPackageId = memberObj.packageId;
        this.singleInvoicePrint.feeStatus = this.fund.status;
        this.singleInvoicePrint.feeAmount = this.receiptFeeAmount();
        this.singleInvoicePrint.balance = this.fund.remainingBalance;
        this.singleInvoicePrint.taxOnFee = Number(this.fund.tax) || 0;
        this.singleInvoicePrint.discountOnFee = this.discountAmount || 0;

        // Prefer SRB IDs returned on each split fee row (one per payment mode).
        this.srbInvoiceLines = buildSplitSrbInvoiceLines(fees || []);
        this.srbInvoiceId = this.srbInvoiceLines.length === 1
            ? String((fees || []).find((f) => f?.SRBInvoiceID)?.SRBInvoiceID || '')
            : '';
        this.fbrInvoiceLines = buildSplitFbrInvoiceLines(fees || []);
        this.fbrInvoiceId = this.fbrInvoiceLines.length === 1 ? this.fbrInvoiceLines[0] : '';

        await this.printInvoice({ ...this.singleInvoicePrint });
        this.taxType = savedTaxType;
        this.srbInvoiceLines = [];
        this.srbInvoiceId = '';
        this.fbrInvoiceLines = [];
        this.fbrInvoiceId = '';
    }

    private submitSplitPayment(memberObj: any): void {
        if (!this.isSplitFormValid()) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: this.setLabel('splitValidationErrorSummaryLabel'),
                detail: this.splitValidationMessage || this.setLabel('splitAllocationMismatchErrorLabel'),
            });
            return;
        }
        this.syncSplitTotalsForSubmit();
        this.fund.paymentMode = this.setLabel('multiplePaymentModesLabel');
        const splitsForApi = this.buildSplitLinesForSubmit();
        const payload = buildPayFundSplitPayload(
            memberObj,
            this.fund as unknown as Record<string, unknown>,
            splitsForApi,
        );
        this.appServiceManager.post(payFundSplitUrl(this.user.branch), payload).subscribe(
            async (res: any) => {
                if (res?.status) {
                    await this.printSplitInvoiceUsingExistingTemplate(
                        memberObj,
                        res.fees || [],
                    );
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "success",
                        summary: "Success Message",
                        detail: "Member Fee Submitted",
                    });
                    this.dataService.refreshDefaulter("refreshDefaulters");
                    if (memberObj.isDelete || memberObj.freezeDetail?.isFreeze) {
                        this.showActiceFreezeBox = true;
                    }
                    this.isFeeSubmitting = false;
                    this.closeFeeCollectionDialog.emit();
                } else {
                    this.isFeeSubmitting = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: formatApiErrorDetail(null, 'Something Went Wrong', res?.error),
                    });
                }
            },
            (error) => {
                this.isFeeSubmitting = false;
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: formatApiErrorDetail(error),
                });
            },
        );
    }

    /** Single merged Save-disabled rule (replaces the duplicated buttons). */
    isSaveDisabled(form: any): boolean {
        const discountTooHigh = this.isTrainerFee()
            ? (Number(this.discountAmount) || 0) > this.trainerGrossFee()
            : this.discountAmount > this.fund.pay;
        const trainerBlocked =
            this.isTrainerFee() &&
            (this.trainerFeeBlocked ||
                this.billingStatusLoading ||
                !this.trainerBillingEndDate);
        const base =
            this.isFeeSubmitting ||
            !form?.valid ||
            this.feegreater == true ||
            this.feealreadypaid == true ||
            (this.payNewPeriod && !!this.payNewPeriodBlockedMessage) ||
            this.trainerNotSelected ||
            trainerBlocked ||
            discountTooHigh;
        if (this.multiplePaymentModesEnabled) {
            return base || !this.isSplitFormValid();
        }
        return base;
    }
    fileChangeEvent(event: any): void {
        const file: File = event.target.files[0];
        this.selectedFileName = file.name;
        this.modifiedFileName = file.name + ":" + this.user.company + ":" + this.user.branch;
        const modifiedFile = new File([file], this.modifiedFileName, { type: file.type });
        this.selectedFile = modifiedFile;
    }

    uploadReceipt(formData: FormData): Observable<any> {

        return this.appServiceManager.post('branches/' + AuthService.getLoggedInBranch() + '/customers/upload/fee-receipt-only', formData).toPromise()
            .then((res: any) => {
                this.selectedFileName = res.data.feeReceiptImageUrl;
            })
            .catch(error => {
                // Handle errors if needed
            });
    }

    showDialog() {
        this.feePaidWarningShown = false;
        this.resetSplitState();
        this.selectedFileName = "";
        this.trainerSessions = this.member.customerstrainer.sessionCount;
        this.showTrainerFeeError = false;
        this.showRegistrationFeeError = false;
        this.showMonthlyFeeError = false;
        this.openFeeDialog = false;
        this.discountAmount = 0;
        this.previousDueDate = this.member.settings.dueDate;
        this.fund.previousDueDate = this.member.settings.dueDate;
        var date = new Date();
        this.fund.status = "Monthly Fee - Paid";
        this.selectedFeePackageId = 'primary';
        if (this.member.settings.dueDate) {
            this.member.monthFee = this.packageFee;
            this.fund.pay = parseInt(this.member.monthFee);
            this.validateDiscount();
            let percentagePaid = this.fund.pay / parseInt(this.member.monthFee) * 100;
            let numberOfDays: any = '';
            if(this.durationType == 'months'){
                if (this.numOfMonths < 2) {
                    if (this.fund.pay != parseInt(this.member.monthFee)) {
                        numberOfDays = (percentagePaid / 100) * 30;
                    } else {
                        numberOfDays = moment(this.member.settings.dueDate); // Assuming a month is 30 days for other cases.
                        numberOfDays = numberOfDays.daysInMonth();
                        console.log("numberOfDays", numberOfDays)
                    }
                    numberOfDays = Math.floor(numberOfDays);
                }
                else {
                    let months = [];
                    months[0] = moment(this.member.settings.dueDate);
                    months[0] = months[0].daysInMonth();
                    let futureDate = moment(this.member.settings.dueDate)
                    for (let i = 0; i < this.numOfMonths - 1; i++) {
                        futureDate = moment(futureDate).add(months[i], 'days');
                        months[i + 1] = futureDate.daysInMonth();
                        console.log("monthss:", months[i + 1]);
                        numberOfDays += Math.floor(months[i]);
                        numberOfDays = Math.floor(numberOfDays);
                    }
                    numberOfDays += Math.floor(months[this.numOfMonths - 1]);
                    numberOfDays = Math.floor(numberOfDays);
                }
            }
            else if(this.durationType == 'days'){
                numberOfDays = this.noOfDays;
            }
            else if(this.durationType == 'weeks'){
                numberOfDays = this.noOfWeeks * 7 ;
            }


            let futureDate = moment(this.member.settings.dueDate).add(numberOfDays, 'days').toISOString();
            console.log("futureDate", futureDate)

            if (this.fund.status == "Fine Fee - Paid") {
                this.fund.dueDate = new Date();
                this.fund.day = new Date().getDate().toString();
            } else if (this.fund.status !== 'Monthly Fee - Paid') {
                this.fund.dueDate = new Date(futureDate);
                this.fund.day = new Date(futureDate).getDate().toString();
            }
            this.fund.date = new Date();

            applyDefaultFundMonthYear(this.fund, true);
            this.fundInvoice.pay = parseInt(this.member.monthFee);
            this.fundInvoice.date = new Date();
            this.dialogVisibility = this.isDialogVisible;
            var obj = {
                index: 1,
            };
            this.handleChange(obj);
            this.feeChange();
        } else {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please Set Due Date in Member Setting!",
            });
        }
    }

    onFeeChanged(newPay?: number | string) {
        if (this.syncingTrainerPay) return;
        if (this.isTrainerFee()) {
            this.syncTrainerCollectedPay();
            this.validateDiscount();
            this.checkfeegreater();
            return;
        }
        if (newPay !== undefined && newPay !== null && newPay !== '') {
            this.fund.pay = Number(newPay);
        }
        this.checkfeegreater();
        this.validateDiscount();
        if (this.fund.status !== 'Monthly Fee - Paid') {
            this.updateDueDateBasedOnPartialPayment();
        }
        if (this.walletAmountPaid) {
            this.checkWalletBalance(this.walletAmountPaid);
        }
    }


    updateDueDateBasedOnPartialPayment() {
        const pay = this.fund.pay || 0;
        const discount = this.discountAmount || 0;
        const tax = this.taxRate || 0;
        this.calculatedTax =(discount == pay && this.isDiscountFormulaReverse )?0: (pay * tax) / 100 ;

        if (this.taxType === 'WITH_TAX') {
            if (discount == pay) {
                this.totalFeePaid = 0;
            } else {
                this.totalFeePaid = (pay - discount) + this.calculatedTax;
            }
        }
        else if (this.taxType === 'INCLUDING_TAX') {
            this.totalFeePaid = (pay - discount);
        }
        else {
            this.totalFeePaid = (pay - discount);
        }

        const monthlyFee = parseInt(this.member.monthFee);
        const payment = this.fund.pay;
        const numOfMonths = this.numOfMonths || 1;
        const totalFee = monthlyFee;

        if (payment > 0 && totalFee > 0) {

            const percentagePaid = (payment / totalFee) * 100;
            let totalDays = 0;
            let currentDate = moment(this.member.settings.dueDate);
            for (let i = 0; i < numOfMonths; i++) {
                totalDays += currentDate.daysInMonth();
                currentDate = currentDate.add(1, 'month');
            }

            let numberOfDays = Math.floor((percentagePaid / 100) * totalDays);
            let futureDate = moment(this.member.settings.dueDate).add(numberOfDays, 'days').toISOString();
            this.fund.dueDate = new Date(futureDate);

            console.log("Updated Due Date:", this.fund.dueDate);
        } else {
            console.warn("Invalid payment or package fee. Cannot update due date.");
        }
    }
    validateDiscount(){
        if (this.isTrainerFee()) {
            this.syncTrainerCollectedPay();
        }
        const pay = this.isTrainerFee() ? this.trainerGrossFee() : (this.fund.pay || 0);
        const discount = this.discountAmount || 0;
        const tax = this.taxRate || 0;
        this.calculatedTax =(discount == pay && this.isDiscountFormulaReverse )?0: (pay * tax) / 100 ;

       if (this.taxType === 'WITH_TAX') {
            if (discount == pay) {
                this.totalFeePaid = 0;
            } else {
                this.totalFeePaid = (pay - discount) + this.calculatedTax;
            }
        }
        else if (this.taxType === 'INCLUDING_TAX') {
            this.totalFeePaid = (pay - discount);
        }
        else {
            this.totalFeePaid = (pay - discount);
        }
        if (this.fund.status === 'Monthly Fee - Paid' && this.discountAmount > this.fund.pay) {
            this.showMonthlyFeeError = true;
        } else if (this.fund.status === 'Registration Fee - Paid' && this.discountAmount > this.fund.pay) {
            this.showRegistrationFeeError = true;
        } else if (this.isTrainerFee() && this.discountAmount > this.trainerGrossFee()) {
            this.showTrainerFeeError = true;
        } else {
            this.showTrainerFeeError = false;
            this.showRegistrationFeeError = false;
            this.showMonthlyFeeError = false;
        }
        if (this.fund.status === 'Monthly Fee - Paid') {
            this.updateMonthlyFeeDueDatePreview();
        }
        this.recalculateAllSplitRows();
    }

    handleChange(e) {
        if (e.index === 1) {
            if (!this.member.settings.dueDate) {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: "Due Date is not Selected!",
                });
            }
        }
    }

    getTotalForAllReciptPrint() {
        let memberFeeDetails = [];
        this.printAllZeroValues();
        memberFeeDetails = JSON.parse(this.feeDetailsSource);
        memberFeeDetails.map(memberFee => {
            const pay = parseInt(memberFee.pay ?? 0, 10) || 0;
            const discount = parseInt(memberFee.discount ?? 0, 10) || 0;
            if (memberFee.status === "Registration Fee - Paid") {
                this.printAllFeeTotal.totalRegistationFee += pay;
            }
            else if (memberFee.status === "Trainer Fee - Paid") {
                this.printAllFeeTotal.totalTrainerFee += pay;
            }
            else if (memberFee.status === "Monthly Fee - Paid") {
                this.printAllFeeTotal.totalMonthlyFee += pay;
            }

            else if (memberFee.status === "Fine Fee - Paid") {
                this.printAllFeeTotal.totalFineFee += pay;
            }
            this.printAllFeeTotal.totalDiscountFee += discount;
            this.printAllFeeTotal.feeGrandTotal += pay;
        });
    }

    printAllZeroValues() {
        this.printAllFeeTotal.totalRegistationFee = 0;
        this.printAllFeeTotal.totalDiscountFee = 0;
        this.printAllFeeTotal.totalTrainerFee = 0;
        this.printAllFeeTotal.totalMonthlyFee = 0;
        this.printAllFeeTotal.totalFineFee = 0;
        this.printAllFeeTotal.feeGrandTotal = 0;
    }

    isTrainerFee(): boolean {
        return this.fund?.status === 'Trainer Fee - Paid';
    }

    trainerGrossFee(): number {
        return Math.max(0, Math.round(Number(this.trainerLockedFee) || 0));
    }

    trainerCollectedPay(): number {
        const discount = Math.max(0, Math.round(Number(this.discountAmount) || 0));
        return Math.max(0, this.trainerGrossFee() - Math.min(discount, this.trainerGrossFee()));
    }

    private receiptFeeAmount(): number {
        return this.isTrainerFee() ? this.trainerGrossFee() : (Number(this.fund?.pay) || 0);
    }

    private syncingTrainerPay = false;

    private syncTrainerCollectedPay(): void {
        if (!this.isTrainerFee() || this.syncingTrainerPay) return;
        this.syncingTrainerPay = true;
        const collected = this.trainerCollectedPay();
        if (Number(this.fund.pay) !== collected) {
            this.fund.pay = collected;
        }
        this.amountDue = this.trainerGrossFee();
        this.difference = this.trainerGrossFee();
        this.fund.remainingBalance = 0;
        this.syncingTrainerPay = false;
    }

    private clearTrainerPeriod(): void {
        this.trainerLockedFee = 0;
        this.trainerFullPackageFee = 0;
        this.trainerPeriodStartLabel = '';
        this.trainerBillingEndDate = null;
        this.trainerOriginalPeriodStart = null;
        this.trainerOriginalPeriodEnd = null;
        this.trainerFeeBlocked = false;
        this.feePaidUntilLabel = '';
        this.canPayAdvance = false;
        this.feealreadypaid = false;
    }

    stampShortenedBillingOnFund(): void {
        if (this.isTrainerFee()) {
            const start = this.trainerOriginalPeriodStart;
            const end = this.trainerBillingEndDate ?? this.trainerOriginalPeriodEnd;
            if (!start || !end) return;
            const endDay = new Date(end.getTime());
            endDay.setHours(0, 0, 0, 0);
            const startDay = new Date(start.getTime());
            startDay.setHours(0, 0, 0, 0);
            this.syncTrainerCollectedPay();
            this.fund.billingPeriodStart = toBillingDateString(startDay);
            this.fund.billingPeriodEnd = toBillingDateString(endDay);
            this.fund.billingPackageFee = this.trainerGrossFee();
            this.fund.dueDate = endDay;
            this.fund.nextDueDate = endDay;
            this.fund.dueDateAfterApproval = endDay;
            this.fund.day = String(endDay.getDate());
            this.fund.month = startDay.getMonth() + 1;
            this.fund.year = startDay.getFullYear();
            this.fund.previousDueDate = toBillingDateString(startDay);
            this.fund.oldDate = toBillingDateString(startDay);
            this.fund.discount = Math.max(0, Math.round(Number(this.discountAmount) || 0));
            this.invoicePeriodStart = startDay;
            this.invoicePeriodEnd = endDay;
            this.numOfMonths = 1;
            if (this.fundInvoice) {
                this.fundInvoice.pay = this.trainerGrossFee();
                this.fundInvoice.day = String(endDay.getDate());
                this.fundInvoice.month = startDay.getMonth() + 1;
                this.fundInvoice.year = startDay.getFullYear();
            }
            return;
        }
        if (this.fund.status !== 'Monthly Fee - Paid' || this.isSecondaryFeeSelected()) {
            delete this.fund.billingPackageFee;
            return;
        }
        const end = this.billingEndDate ?? this.originalBillingPeriodEnd;
        const originalEnd = this.originalBillingPeriodEnd;
        const shortened = Boolean(
            end &&
            originalEnd &&
            toBillingDateString(end) !== toBillingDateString(originalEnd),
        );
        if (!shortened || !end) {
            // Same end as billing status: each member keeps the period the server calculated.
            delete this.fund.billingPackageFee;
            delete this.fund.billingPeriodEnd;
            delete this.fund.billingPeriodDays;
            return;
        }
        this.fund.billingPackageFee = this.billingPeriodFeeCeiling;
        const shareDayCount =
            this.numberOfMemberFeeToBePaid > 1 && !this.isSameHistoryActive();
        if (shareDayCount && this.originalBillingPeriodStart) {
            this.fund.billingPeriodDays = inclusiveBillingDayCount(
                this.originalBillingPeriodStart,
                end,
            );
            delete this.fund.billingPeriodEnd;
            return;
        }
        delete this.fund.billingPeriodDays;
        this.fund.billingPeriodEnd = toBillingDateString(end);
        if (this.originalBillingPeriodStart) {
            this.fund.billingPeriodStart = toBillingDateString(this.originalBillingPeriodStart);
        }
    }

    onBillingEndDateChange(selected?: Date | null): void {
        if (this.isTrainerFee()) {
            const start = this.trainerOriginalPeriodStart;
            const originalEnd = this.trainerOriginalPeriodEnd;
            if (!start || !originalEnd) return;
            const raw = selected instanceof Date ? selected : this.trainerBillingEndDate;
            const picked = parseLocalBillingDate(raw);
            if (!picked) return;
            let end = picked;
            if (end.getTime() < start.getTime()) end = new Date(start.getTime());
            if (end.getTime() > originalEnd.getTime()) end = new Date(originalEnd.getTime());
            this.trainerBillingEndDate = end;
            this.trainerLockedFee = prorateFeeForShortenedEnd({
                periodStart: start,
                originalEnd,
                selectedEnd: end,
                fullFee: this.trainerFullPackageFee,
            });
            if ((Number(this.discountAmount) || 0) > this.trainerLockedFee) {
                this.discountAmount = this.trainerLockedFee;
            }
            this.stampShortenedBillingOnFund();
            this.validateDiscount();
            this.checkfeegreater();
            return;
        }
        if (this.suppressBillingEndAdjust || this.billingAlreadyPaid > 0) {
            return;
        }
        const edited = parseLocalBillingDate(selected ?? this.billingEndDate);
        const start = this.originalBillingPeriodStart;
        const originalEnd = this.originalBillingPeriodEnd;
        if (!edited || !start || !originalEnd) return;
        if (edited.getTime() < start.getTime() || edited.getTime() > originalEnd.getTime()) {
            this.billingEndDate = new Date(originalEnd);
            return;
        }
        this.billingEndDate = edited;
        const ceiling = prorateBillingPackageFee(
            this.originalBillingPackageFee,
            start,
            originalEnd,
            edited,
        );
        this.billingPeriodFeeCeiling = ceiling;
        this.amountDue = ceiling;
        this.billingNetPackageFee = ceiling;
        this.difference = ceiling;
        this.fund.remainingBalance = ceiling;
        this.fund.pay = ceiling;
        this.invoicePeriodEnd = edited;
        this.fund.billingPeriodEnd = toBillingDateString(edited);
        this.fund.billingPackageFee = ceiling;
        this.validateDiscount();
        this.updateMonthlyFeeDueDatePreview();
        this.checkfeegreater();
    }

    async loadTrainerBillingStatus(): Promise<void> {
        if (!this.member?._id || !this.isTrainerFee()) return;
        this.trainerNotSelected = false;
        this.trainerFeeBlocked = false;
        this.clearTrainerPeriod();
        const trainer = this.member.customerstrainer;
        const assigned = this.member.question3 === 'YES' && !!trainer;
        if (!assigned) {
            this.trainerNotSelected = true;
            this.fund.pay = 0;
            this.trainerLockedFee = 0;
            return;
        }
        const totalFees = parseInt(trainer.totalFees, 10) || 0;
        if (totalFees <= 0) {
            this.trainerFeeBlocked = true;
            this.fund.pay = 0;
            this.trainerLockedFee = 0;
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: 'Trainer fee must be greater than 0.',
            });
            return;
        }
        this.billingStatusLoading = true;
        this.feePaidUntilLabel = '';
        try {
            const res: any = await this.appServiceManager
                .post(
                    trainerBillingStatusUrl(this.user.branch),
                    buildTrainerBillingStatusPayload(this.member._id, this.payAdvance),
                )
                .toPromise();
            const data = res?.data ?? res;
            if (!data?.billingPeriodStart || !data?.billingPeriodEnd) {
                this.fund.pay = 0;
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error Message',
                    detail: 'Trainer billing period is not available.',
                });
                return;
            }
            this.canPayAdvance = Boolean(data.canPayAdvance);
            this.feePaidUntilLabel = this.buildFeePaidUntilLabel(data);
            this.feealreadypaid = data.status === 'Paid' && !this.payAdvance;
            if (this.feealreadypaid) {
                this.trainerOriginalPeriodStart = null;
                this.trainerOriginalPeriodEnd = null;
                this.trainerBillingEndDate = null;
                this.trainerPeriodStartLabel = '';
                this.billingPeriodLabel = data.billingPeriodLabel ?? '';
                this.trainerFullPackageFee = Math.round(Number(data.billingPackageFee) || 0);
                this.trainerLockedFee = 0;
                this.fund.pay = 0;
                this.discountAmount = 0;
                this.feegreater = false;
                this.billingNetPackageFee = Number(data.netPackageFee) || 0;
                this.billingAlreadyPaid = Number(data.alreadyPaid) || 0;
                const paidUntil = parseLocalBillingDate(
                    data.settingsDueDate ?? data.billingPeriodEnd,
                );
                if (paidUntil) {
                    this.fund.dueDate = paidUntil;
                    this.fund.nextDueDate = paidUntil;
                }
                if (this.feePaidUntilLabel) {
                    this.feePaidWarningShown = false;
                    this.queueFeePaidWarningPopup();
                }
                return;
            }
            const start = parseLocalBillingDate(data.billingPeriodStart);
            const end = parseLocalBillingDate(data.billingPeriodEnd);
            if (!start || !end) {
                this.fund.pay = 0;
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error Message',
                    detail: 'Trainer billing period is not available.',
                });
                return;
            }
            this.trainerOriginalPeriodStart = new Date(start.getTime());
            this.trainerOriginalPeriodEnd = new Date(end.getTime());
            this.trainerBillingEndDate = new Date(end.getTime());
            this.trainerPeriodStartLabel = start.toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'short',
            });
            this.billingPeriodLabel = data.billingPeriodLabel ?? '';
            const fullFee = Math.round(
                Number(data.billingPackageFee) || Number(data.amountDue) || 0,
            );
            this.trainerFullPackageFee = fullFee;
            this.trainerLockedFee = fullFee;
            if (this.trainerLockedFee <= 0) {
                this.trainerFeeBlocked = true;
                this.fund.pay = 0;
                return;
            }
            this.discountAmount = 0;
            this.feegreater = false;
            this.billingNetPackageFee = Number(data.netPackageFee) || this.trainerLockedFee;
            this.billingAlreadyPaid = Number(data.alreadyPaid) || 0;
            this.stampShortenedBillingOnFund();
            this.validateDiscount();
        } catch (error) {
            this.fund.pay = 0;
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: formatApiErrorDetail(error),
            });
        } finally {
            this.billingStatusLoading = false;
        }
    }

    async loadBillingStatus(): Promise<void> {
        if (!this.member?._id || this.fund.status !== 'Monthly Fee - Paid') {
            return;
        }
        if (this.isSecondaryFeeSelected()) {
            return;
        }
        this.billingStatusLoading = true;
        this.feePaidUntilLabel = '';
        try {
            const res: any = await this.appServiceManager
                .post(
                    billingStatusUrl(this.user.branch),
                    buildBillingStatusPayload(
                        this.member._id,
                        this.payAdvance,
                        this.payNewPeriod && !this.payNewPeriodBlockedMessage,
                    ),
                )
                .toPromise();
            const data = res?.data ?? res;
            if (!data) return;

            this.billingPeriodLabel = data.billingPeriodLabel ?? '';
            this.suppressBillingEndAdjust = true;
            this.rememberOriginalBillingPeriod(data);
            this.syncInvoiceBillingPeriodFromStatus(data);
            this.amountDue = Number(data.amountDue) || 0;
            this.billingNetPackageFee = Number(data.netPackageFee) || 0;
            this.billingAlreadyPaid = Number(data.alreadyPaid) || 0;
            this.billingPeriodFeeCeiling = this.originalBillingPackageFee;
            this.canPayAdvance = Boolean(data.canPayAdvance);
            this.canPayNewPeriod = Boolean(data.canPayNewPeriod);
            this.payNewPeriodBlockedMessage = data.payNewPeriodBlockedMessage
                ? String(data.payNewPeriodBlockedMessage)
                : '';
            if (!this.canPayNewPeriod) {
                this.payNewPeriod = false;
            }
            this.feePaidUntilLabel = this.buildFeePaidUntilLabel(data);
            this.difference = this.amountDue;
            this.fund.remainingBalance = this.amountDue;
            this.fund.pay = this.amountDue;
            // Free packages return amountDue=0 but are still collectible; only block when period is Paid.
            this.feealreadypaid = data.status === 'Paid' && !this.payAdvance && !this.payNewPeriod;

            this.validateDiscount();
            this.updateMonthlyFeeDueDatePreview();
            this.checkfeegreater();
            if (this.feePaidUntilLabel) {
                this.queueFeePaidWarningPopup();
            }
        } catch (error) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: formatApiErrorDetail(error),
            });
        } finally {
            this.suppressBillingEndAdjust = false;
            this.billingStatusLoading = false;
        }
    }

    private rememberOriginalBillingPeriod(data: {
        billingPeriodStart?: string;
        billingPeriodEnd?: string;
        billingPackageFee?: number;
    }): void {
        this.originalBillingPeriodStart = parseLocalBillingDate(data.billingPeriodStart);
        this.originalBillingPeriodEnd = parseLocalBillingDate(data.billingPeriodEnd);
        this.originalBillingPackageFee = Math.round(Number(data.billingPackageFee) || 0);
        this.billingEndDate = this.originalBillingPeriodEnd
            ? new Date(this.originalBillingPeriodEnd)
            : null;
        this.billingPeriodFeeCeiling = this.originalBillingPackageFee;
    }

    isBillingEndLocked(): boolean {
        return this.billingAlreadyPaid > 0 || this.billingStatusLoading;
    }

    billingPeriodStartLabel(): string {
        const start = this.originalBillingPeriodStart;
        if (!start) return '';
        return start.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    }

    private syncInvoiceBillingPeriodFromStatus(data: {
        billingPeriodStart?: string;
        billingPeriodEnd?: string;
    }): void {
        if (this.fund.status !== 'Monthly Fee - Paid' && !this.isTrainerFee()) {
            this.invoicePeriodStart = null;
            this.invoicePeriodEnd = null;
            return;
        }
        this.invoicePeriodStart = parseLocalBillingDate(data.billingPeriodStart);
        this.invoicePeriodEnd = parseLocalBillingDate(data.billingPeriodEnd);
        if (data.billingPeriodStart) {
            this.fund.billingPeriodStart = data.billingPeriodStart;
        }
        if (data.billingPeriodEnd) {
            this.fund.billingPeriodEnd = data.billingPeriodEnd;
        }
        if (!this.isTrainerFee() && this.previousDueDate) {
            this.fund.previousDueDate = this.previousDueDate;
        }
    }

    private syncFundDueDateSnapshotsForInvoice(): void {
        if (this.isTrainerFee()) {
            this.stampShortenedBillingOnFund();
            return;
        }
        if (this.fund.status !== 'Monthly Fee - Paid') {
            return;
        }
        if (this.previousDueDate) {
            this.fund.previousDueDate = this.previousDueDate;
        }
        if (this.fund.dueDate) {
            this.fund.nextDueDate = this.fund.dueDate;
        }
    }

    private updateMonthlyFeeDueDatePreview(): void {
        if (this.fund.status !== 'Monthly Fee - Paid') {
            return;
        }
        const due = resolveMonthlyFeeDueDatePreview({
            billingPeriodStart:
                this.fund.billingPeriodStart ?? this.invoicePeriodStart,
            billingPeriodEnd:
                this.fund.billingPeriodEnd ?? this.invoicePeriodEnd,
            netPackageFee: this.billingNetPackageFee,
            alreadyPaid: this.billingAlreadyPaid,
            payAmount: Number(this.fund.pay) || 0,
            discountAmount: Number(this.discountAmount) || 0,
        });
        if (due) {
            this.fund.dueDate = due;
            this.fund.nextDueDate = due;
            this.fund.day = String(due.getDate());
        }
        this.syncFundDueDateSnapshotsForInvoice();
    }

    private stampInvoicePeriodOnPrint(printData: Record<string, unknown>): void {
        this.syncFundDueDateSnapshotsForInvoice();
        const { periodStart, periodEnd } = resolveInvoicePeriodDates({
            status: this.fund.status,
            billingPeriodStart:
                printData.billingPeriodStart ??
                this.fund.billingPeriodStart ??
                this.invoicePeriodStart,
            billingPeriodEnd:
                printData.billingPeriodEnd ??
                this.fund.billingPeriodEnd ??
                this.invoicePeriodEnd,
            previousDueDate:
                printData.previousDueDate ??
                this.fund.previousDueDate ??
                this.fund.oldDate ??
                this.previousDueDate,
            dueDate: printData.dueDate,
            nextDueDate:
                printData.nextDueDate ??
                this.fund.nextDueDate ??
                this.fund.dueDateAfterApproval ??
                this.fund.dueDate,
            day: printData.day,
            month: printData.month,
            year: printData.year,
        });
        printData.previousDueDate = periodStart;
        printData.nextDueDate = periodEnd;
        printData.billingPeriodStart = periodStart;
        printData.billingPeriodEnd = periodEnd;
    }

    getInvoicePeriodStartLabel(): string {
        // Receipt display only: +1 unless first fee (prev === billing start).
        return formatFeeInvoicePeriodStart({
            status: this.fund.status,
            previousDueDate:
                this.fund.previousDueDate ??
                this.fund.oldDate ??
                this.previousDueDate,
            billingPeriodStart:
                this.fund.billingPeriodStart ?? this.invoicePeriodStart,
            nextDueDate:
                this.fund.nextDueDate ??
                this.fund.dueDateAfterApproval ??
                this.fund.dueDate,
        });
    }

    getInvoicePeriodEndLabel(): string {
        return formatInvoiceBillingDate(
            parseLocalBillingDate(this.fund.nextDueDate) ??
                this.fund.dueDateAfterApproval ??
                this.fund.dueDate,
        );
    }

    private getPrintInvoicePeriodLabels(printData: Record<string, unknown>): {
        periodStartLabel: string;
        periodEndLabel: string;
    } {
        // Capture real period start before stamp overwrites printData fields.
        const billingPeriodStart =
            this.fund.billingPeriodStart ??
            this.invoicePeriodStart ??
            printData.billingPeriodStart;
        this.stampInvoicePeriodOnPrint(printData);
        return {
            periodStartLabel: formatFeeInvoicePeriodStart({
                status: String(printData.status ?? this.fund.status ?? ''),
                previousDueDate: printData.previousDueDate,
                billingPeriodStart,
                nextDueDate: printData.nextDueDate,
            }),
            periodEndLabel: formatInvoiceBillingDate(printData.nextDueDate),
        };
    }

    onPayAdvanceToggle(): void {
        if (this.payAdvance) {
            this.payNewPeriod = false;
        }
        if (this.isTrainerFee()) {
            void this.loadTrainerBillingStatus();
            return;
        }
        this.loadBillingStatus();
    }

    get payNewPeriodBlockedLine1(): string {
        const message = this.payNewPeriodBlockedMessage || '';
        const splitAt = message.indexOf('. ');
        if (splitAt === -1) return message;
        return message.slice(0, splitAt + 1);
    }

    get payNewPeriodBlockedLine2(): string {
        const message = this.payNewPeriodBlockedMessage || '';
        const splitAt = message.indexOf('. ');
        if (splitAt === -1) return '';
        return message.slice(splitAt + 2);
    }

    onPayNewPeriodToggle(): void {
        if (this.payNewPeriod) {
            this.payAdvance = false;
        }
        if (this.payNewPeriod && this.payNewPeriodBlockedMessage) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'warn',
                summary: 'Warning Message',
                detail: this.payNewPeriodBlockedMessage,
            });
            return;
        }
        this.loadBillingStatus();
    }

    private buildFeePaidUntilLabel(data: {
        status?: string;
        amountDue?: number;
        settingsDueDate?: string | null;
        billingPeriodEnd?: string;
    }): string {
        if (this.payAdvance || this.payNewPeriod || data.status !== 'Paid' || Number(data.amountDue) > 0) {
            return '';
        }
        const untilRaw = resolveFeePaidUntilRaw(
            data.settingsDueDate,
            data.billingPeriodEnd,
        );
        if (!untilRaw) return '';
        const until = moment(untilRaw);
        if (!until.isValid()) return '';
        return until.format('D MMM YYYY');
    }

    getFeePaidWarningText(): string {
        const prefix = this.setLabel('feePaidUntilLabel') || 'Fee paid until';
        if (this.feePaidUntilLabel) {
            return `${prefix} ${this.feePaidUntilLabel}`;
        }
        return this.setLabel('feeAlreadyPaidLabel') || 'Fee already paid';
    }

    queueFeePaidWarningPopup(): void {
        if (this.feePaidWarningShown || !this.feePaidUntilLabel) {
            return;
        }
        setTimeout(() => {
            if (this.feePaidWarningShown || !this.feePaidUntilLabel) {
                return;
            }
            this.feePaidWarningShown = true;
            this.showFeePaidWarningPopup();
        }, 100);
    }

    showFeePaidWarningPopup(): void {
        this.messageService.add({
            severity: 'warn',
            summary: this.setLabel('warningLabel') || 'Warning',
            detail: this.getFeePaidWarningText(),
            life: 8000,
        });
    }

    checkFeePaid(month: any, year: any) {
        // this.getCustomerByID();

        this.registrationPaid = false;
        this.monthlyPaid = false;
        this.trainerPaid = false;

        // Check if there is at least one entry with 'Registration Fee - Paid'
        const hasRegistrationFeePaid = this.customerFees.some((fee) => {
            return fee.status === 'Registration Fee - Paid';
        });

        if (hasRegistrationFeePaid) {
            this.registrationPaid = true;
        }

        for (const fee of this.customerFees) {
            if (fee.month == month && fee.year == year) {
                if (fee.status == 'Monthly Fee - Paid') {
                    this.monthlyPaid = true;
                } else if (this.member.question3 == 'YES' && fee.status == 'Trainer Fee - Paid') {
                    this.trainerPaid = true;
                }
            }
        }
    }

    feeChange() {
        if (!this.isTrainerFee()) {
            this.trainerNotSelected = false;
            this.trainerFeeBlocked = false;
            this.clearTrainerPeriod();
        }
        if (this.fund.status !== 'Monthly Fee - Paid') {
            this.payAdvance = false;
            this.payNewPeriod = false;
        }
        this.showTrainerFeeError = false;
        this.showRegistrationFeeError = false;
        this.showMonthlyFeeError = false;
        if(this.fund.status === 'Registration Fee - Paid'){
            this.otherGroupMembersList = [];
            this.numberOfMemberFeeToBePaid = 1;
        }
        this.checkFeePaid(this.fund.month, this.fund.year);
        if (this.fund.status === 'Monthly Fee - Paid') {
            if (this.isSecondaryFeeSelected()) {
                this.onFeePackageChange();
                return;
            }
            this.loadBillingStatus();
            return;
        }
        this.array[0] = this.member._id;
        this.array[1] = this.fund;
        this.array[2] = this.numOfMonths;
        this.member.monthFee = this.packageFee;
        this.trainerNotSelected = false;
        this.trainerFeeBlocked = false;
        if (this.fund.status === "Trainer Fee - Paid") {
            this.otherSelectedGroupMembers = [];
            this.payOtherGroupMemberFee = [];
            this.numberOfMemberFeeToBePaid = 1;
            this.isOtherMemberSelected = false;
            this.walletAmountPaid = false;
            this.walletAmountUsedInput = 0;
            this.payAdvance = false;
            this.payNewPeriod = false;
            this.feePaidWarningShown = false;
            void this.loadTrainerBillingStatus();
        } else if (this.fund.status === "Registration Fee - Paid") {
            this.appServiceManager
                .post(
                    "branches/" +
                        this.user.branch +
                        "/customer-fees/reports/registration-fee",
                    this.array
                )
                .subscribe(
                    (response) => {
                        this.member.registerationFee = this.packageRegistrationFee;
                        this.difference =
                            parseInt(this.member.registerationFee) -
                            response;
                        this.fund.remainingBalance = this.difference;
                        if (this.difference <= 0) {
                            this.fund.pay = this.difference;
                            //this.fund.dueDate = this.member.settings.dueDate;
                            //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
                            if (this.isFeeMessageVisible && !this.monthlyPaid && !this.trainerPaid && this.member.question3 == "YES") {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "error",
                                    summary: "Registration fee already paid.Please check monthly fee and trainer fee.",
                                });
                            } else if (this.monthlyPaid && this.member.question3 == "YES" && !this.trainerPaid) {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "error",
                                    summary: "Registration fee already paid.Please check trainer fee.",
                                });
                            } else if (!this.monthlyPaid && this.member.question3 == "YES" && this.trainerPaid) {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "error",
                                    summary: "Registration Fee already paid.Please check monthly fee.",
                                });
                            } else if (this.monthlyPaid && this.member.question3 == "YES" && this.trainerPaid) {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "warn",
                                    summary: "Fee already paid.",
                                });
                            } else if (this.member.question3 == "NO" && this.monthlyPaid) {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "warn",
                                    summary: "Fee already paid.",
                                });
                            }
                            this.feealreadypaid = true;
                        } else {
                            this.fund.pay = this.difference;
                            this.validateDiscount();
                            this.fundInvoice.pay = this.difference;
                            //this.fund.dueDate = this.member.settings.dueDate;
                            //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
                            this.feealreadypaid = false;
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "error",
                            summary: "Error Message",
                            detail: formatApiErrorDetail(error),
                        });
                    }
                );
        } else if (this.fund.status === "Monthly Fee - Paid") {
            if (parseInt(this.member.monthFee) >= 0) {
                if(this.durationType == "months"){
                    this.appServiceManager
                        .post(
                            monthlyFeeReportUrl(this.user.branch),
                            buildMonthlyFeeReportPayload(
                                this.member._id,
                                this.fund as unknown as Record<string, unknown>,
                                this.numOfMonths,
                                this.member.settings?.dueDate,
                            )
                        )
                        .subscribe(
                            (response) => {
                                if (this.packageFee == "0") {
                                    this.member.monthFee = this.packageFee;
                                    this.difference =
                                        parseInt(this.member.monthFee) - response;
                                        this.fund.remainingBalance = this.difference;
                                    this.fund.pay = this.difference;
                                    if (this.fund.pay < 0) {
                                        this.fund.pay = 0;
                                    }
                                    //this.fund.dueDate = this.member.settings.dueDate;
                                    //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
                                    if (this.isFeeMessageVisible) {
                                        if (this.member.question3 == "YES" && !this.trainerPaid) {
                                            this.messageService.clear();
                                            this.messageService.add({
                                                severity: "error",
                                                summary: "Please check trainer fee.",
                                            });
                                        } else if (this.member.question3 == "YES" && this.trainerPaid) {
                                            this.messageService.clear();
                                            this.messageService.add({
                                                severity: "warn",
                                                summary: "Fee already paid.",
                                            });
                                        } else if (this.member.question3 == "NO") {
                                            this.messageService.clear();
                                            this.messageService.add({
                                                severity: "warn",
                                                summary: "Fee already paid.",
                                            });
                                        }
                                    }
                                    this.fund.pay = this.difference;
                                    if (this.fund.pay < 0) {
                                        this.fund.pay = 0;
                                    }
                                    this.fundInvoice.pay = this.difference;
                                    //this.fund.dueDate = this.member.settings.dueDate;
                                    //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
                                    this.feealreadypaid = false;

                                }
                                else {
                                    this.member.monthFee = this.packageFee;
                                    this.difference =
                                        parseInt(this.member.monthFee) - response;
                                    this.fund.remainingBalance = this.difference;
                                    if (this.difference <= 0) {
                                        this.fund.pay = this.difference;
                                        if (this.fund.pay < 0) {
                                            this.fund.pay = 0;
                                        }
                                        //this.fund.dueDate = this.member.settings.dueDate;
                                        //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
                                        if (this.isFeeMessageVisible) {
                                            if (!this.registrationPaid) {
                                                this.messageService.clear();
                                                this.messageService.add({
                                                    severity: "error",
                                                    summary: "Monthly fee already paid.Please check registration fee.",
                                                });
                                            }
                                            else if (this.member.question3 == "YES" && !this.registrationPaid && !this.trainerPaid) {
                                                this.messageService.clear();
                                                this.messageService.add({
                                                    severity: "error",
                                                    summary: "Monthly fee already paid.Please check registration fee and trainer fee.",
                                                });
                                            } else if (!this.trainerPaid && this.member.question3 == "YES") {
                                                this.messageService.clear();
                                                this.messageService.add({
                                                    severity: "error",
                                                    summary: "Monthly fee already paid.Please check trainer fee.",
                                                });
                                            } else if (this.registrationPaid && this.member.question3 == "YES" && this.trainerPaid) {
                                                this.messageService.clear();
                                                this.messageService.add({
                                                    severity: "warn",
                                                    summary: "Fee already paid.",
                                                });
                                            } else if (this.member.question3 == "NO") {
                                                this.messageService.clear();
                                                this.messageService.add({
                                                    severity: "warn",
                                                    summary: "Fee already paid.",
                                                });
                                            }
                                        }
                                        this.feealreadypaid = true;
                                    } else {
                                        this.fund.pay = this.difference;
                                        if (this.fund.pay < 0) {
                                            this.fund.pay = 0;
                                        }
                                        this.validateDiscount();
                                        this.fundInvoice.pay = this.difference;
                                        //this.fund.dueDate = this.member.settings.dueDate;
                                        //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
                                        this.feealreadypaid = false;
                                    }
                                    this.fund.remainingBalance = this.difference;
                                }
                                this.updateDueDateBasedOnPartialPayment();
                            },
                            (error) => {
                                this.loading = false;
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "error",
                                    summary: "Error Message",
                                    detail: formatApiErrorDetail(error),
                                });
                            }
                        );
                }
                else{
                    this.fund.remainingBalance= this.member.monthFee;
                }
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: "Month Fee should be a positive value",
                });
            }

        } else if (this.fund.status === "Fine Fee - Paid") {
            this.fund.pay = 0;
            this.feealreadypaid = false;
            this.fund.dueDate = new Date();
            this.fund.day = new Date().getDate().toString();
        } else {
            this.fund.pay = 0;
        }
    }

    async getPackagesByID() {
        this.loading = true;
        console.log("this.member.packageId", this.member.packageId);

        try {
          const res = await this.appServiceManager.get("branches/" + this.user.branch + "/package-builders/" + this.member.packageId).toPromise();

          // Handle the response
          this.currentPackage = res;
          this.packageName = res.packageName;
          this.numOfMonths = res.noOfMonths;
          this.noOfDays = res.noOfDays;
          this.noOfWeeks = res.noOfWeeks;
          this.packageFee = res.packageFee;
          this.durationType = res.durationType;
          this.numberOfMembers = res.noOfMembers;
          this.packageRegistrationFee = res.registerationFee;
          this.resetTotalFreezingDays= res.freezingDays;
          this.rebuildFeePackageOptions();
          if (this.allowDialog) {
            this.showDialog();
            this.allowDialog = false;
            this.isDialogVisible = true;
            if (this.fund.status === 'Monthly Fee - Paid') {
              await this.loadBillingStatus();
            }
          }
          if(this.currentPackage.groupFeePayByOnePerson) {
            this.getRelatedMembersFromGroup();
          }

          console.log("packageName", this.packageName);
          this.loading = false;
          this.queueFeePaidWarningPopup();
        } catch (error) {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: formatApiErrorDetail(error)
          });
        }
      }

      async getMembersWithSamePackage() {
        try {
            this.membersWithSamePackage = [];
            const date = new Date();
          const res = await this.appServiceManager.get("customers/" + this.branch._id + "/membersWithSamePackage/"+ date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + this.member.packageId).toPromise();
          // Handle the response
          if(res.status) {
            res.response.forEach(element => {
                if(element._id != this.member._id) {
                    const data = {
                    name: element.name + " (" + element.tagNumber + ")",
                    code: element._id
                    };
                    const exist = this.membersWithSamePackage.filter(l => l.memberId == element._id);
                    if(exist.length == 0) {
                        this.membersWithSamePackage.push(data);
                    }
                }
            });
          }
          this.loading = false;
        } catch (error) {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: formatApiErrorDetail(error)
          });
        }
      }


    checkfeegreater() {
        if (this.fund.status === "Fine Fee - Paid") {
            this.feegreater = false;
        } else if (
            this.fund.status === 'Monthly Fee - Paid' &&
            this.amountDue != null &&
            Number(this.fund.pay) > Number(this.amountDue)
        ) {
            this.feegreater = true;
        } else if (
            Number(this.difference) > 0 &&
            Number(this.fund.pay) > Number(this.difference)
        ) {
            this.feegreater = true;
        } else {
            this.feegreater = false;
        }
    }

    onDueDateChange(newDate: Date) {
        this.updateMemberSettingFlag = true;
    }

      // Custom comparison function based on day, month, and year
    compareByDate(a, b) {
        const dateA: any = new Date(`${a.year}-${a.month}-${a.day}`);
        const dateB: any = new Date(`${b.year}-${b.month}-${b.day}`);
        return dateB - dateA;
    }

    addFund() {
        if (this.isFeeSubmitting) {
            return;
        }
        this.fund.discountAmount = this.discountAmount;
        var terminDate: Date;
        var dateInLoop: Date;
        if (this.isTrainerFee()) {
            this.stampShortenedBillingOnFund();
            this.numOfMonths = 1;
        }
        if (this.fund.status == 'Monthly Fee - Paid') {
            this.confirmationBoxMessage = 'Are you sure you want to add monthly fee ?';
        }
        else if (this.fund.status == 'Trainer Fee - Paid') {
            this.confirmationBoxMessage = 'Are you sure you want to add trainer fee ?';
        }
        else if (this.fund.status == 'Registration Fee - Paid') {
            this.confirmationBoxMessage = 'Are you sure you want to add registration fee ?';
        }
        else if (this.fund.status == 'Fine Fee - Paid') {
            this.confirmationBoxMessage = 'Are you sure you want to add fine fee ?';
        }
        this.confirmationService.confirm({
            message: this.confirmationBoxMessage,
            accept: async () => {
                if (this.isFeeSubmitting) {
                    return;
                }
                if (this.payNewPeriod && this.payNewPeriodBlockedMessage) {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'warn',
                        summary: 'Warning Message',
                        detail: this.payNewPeriodBlockedMessage,
                    });
                    return;
                }
                if (this.payNewPeriod && this.numberOfMemberFeeToBePaid > 1) {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'warn',
                        summary: 'Warning Message',
                        detail: 'Pay new period is only available when collecting one member.',
                    });
                    return;
                }
                if (this.isTrainerFee()) {
                    this.syncTrainerCollectedPay();
                    this.stampShortenedBillingOnFund();
                    if (
                        this.trainerNotSelected ||
                        this.trainerFeeBlocked ||
                        !this.trainerBillingEndDate
                    ) {
                        return;
                    }
                    if ((Number(this.discountAmount) || 0) > this.trainerGrossFee()) {
                        return;
                    }
                    if (this.numberOfMemberFeeToBePaid > 1) {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'warn',
                            summary: 'Warning Message',
                            detail: 'Trainer fee can only be collected for one member.',
                        });
                        return;
                    }
                    this.walletAmountPaid = false;
                    this.walletAmountUsedInput = 0;
                    this.numOfMonths = 1;
                }
                if (this.fund.pay !== null && this.fund.pay >= 0) {
                    if (
                        this.isSameHistoryActive() &&
                        !this.isSecondaryFeeSelected() &&
                        this.fund.status === 'Monthly Fee - Paid' &&
                        this.numberOfMemberFeeToBePaid < this.expectedSameHistoryGroupFeeCount()
                    ) {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'warn',
                            summary: 'Warning Message',
                            detail: 'Same history requires monthly fee for every group member.',
                        });
                        return;
                    }
                    this.isFeeSubmitting = true;
                    this.responseCount = 0;
                    let addFeeMonths = 1;
                    if (this.fund.status == "Registration Fee - Paid") {

                        addFeeMonths = 1;
                    }
                    this.fund.pay = Math.round(this.fund.pay / addFeeMonths);
                    if(this.numberOfMemberFeeToBePaid == 1|| this.fund.status == "Registration Fee - Paid") {
                        this.addFeeSinglePersonFee(terminDate,dateInLoop,addFeeMonths, this.memberID,this.member);
                    }
                    else if (this.numberOfMemberFeeToBePaid > 1) {
                        this.addFeeForGroupMembers(terminDate,dateInLoop,addFeeMonths);
                    }
                }
                else {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "warn",
                        summary: "Warning Message",
                        detail: "Monthly Fee Must be greater then -1.",
                    });
                }
            },
        });
    }
    async addFeeForGroupMembers(terminDate,dateInLoop,addFeeMonths) {
        const blocked = await this.groupMemberBlockedByBillingEnd();
        if (blocked) {
            this.isFeeSubmitting = false;
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: blocked,
            });
            return;
        }
        this.addFeeSinglePersonFee(terminDate,dateInLoop,addFeeMonths,this.memberID,this.member);
        this.payOtherGroupMemberFee.forEach(gm => {
            const memberId = this.groupMemberIdAndName(gm).id;
            if (!memberId) return;
            this.appServiceManager.get("branches/" + this.user.branch + "/customers/" + memberId)
            .subscribe((res) => {
                if(res) {
                    this.addFeeSinglePersonFee(terminDate,dateInLoop,addFeeMonths,res._id,res);
                }
            });
        });
    }

    private groupMemberIdAndName(gm: any): { id: string; name: string } {
        if (gm && typeof gm === 'object') {
            const id = String(gm.code ?? gm._id ?? gm.memberId ?? '');
            return { id, name: String(gm.name ?? id) };
        }
        const id = String(gm ?? '');
        const match = [...(this.membersWithSamePackage || []), ...(this.otherGroupMembersList || [])]
            .find((member) => String(member?.code) === id);
        return { id, name: match?.name ? String(match.name) : id };
    }

    private async groupMemberBlockedByBillingEnd(): Promise<string | null> {
        if (this.fund.status !== 'Monthly Fee - Paid' || this.isSecondaryFeeSelected()) {
            return null;
        }
        const chosen = parseLocalBillingDate(this.billingEndDate ?? this.fund.billingPeriodEnd);
        const originalEnd = this.originalBillingPeriodEnd;
        if (!chosen || !originalEnd) return null;
        if (toBillingDateString(chosen) === toBillingDateString(originalEnd)) {
            return null;
        }
        const shareDayCount = !this.isSameHistoryActive();
        const payNewPeriod = this.payNewPeriod && !this.payNewPeriodBlockedMessage;
        for (const gm of this.payOtherGroupMemberFee || []) {
            const { id, name } = this.groupMemberIdAndName(gm);
            if (!id) continue;
            try {
                const res: any = await this.appServiceManager
                    .post(
                        billingStatusUrl(this.user.branch),
                        buildBillingStatusPayload(id, this.payAdvance, payNewPeriod),
                    )
                    .toPromise();
                const data = res?.data ?? res;
                const start = parseLocalBillingDate(data?.billingPeriodStart);
                const end = parseLocalBillingDate(data?.billingPeriodEnd);
                const alreadyPaid = Number(data?.alreadyPaid) || 0;
                if (shareDayCount) {
                    if (alreadyPaid > 0) {
                        return `${name} already has a payment in this billing period. The end date cannot be changed.`;
                    }
                    continue;
                }
                if (!start || !end || chosen.getTime() < start.getTime() || chosen.getTime() > end.getTime()) {
                    const startLabel = start
                        ? start.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })
                        : '';
                    const endLabel = end
                        ? end.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })
                        : '';
                    const range = startLabel && endLabel ? ` Their period is ${startLabel} – ${endLabel}.` : '';
                    return `${name} cannot use this billing end date.${range}`;
                }
                if (alreadyPaid > 0 && chosen.getTime() !== end.getTime()) {
                    return `${name} already has a payment in this billing period. The end date cannot be changed.`;
                }
            } catch (error) {
                return `${name}: ${formatApiErrorDetail(error)}`;
            }
        }
        return null;
    }

    async addFeeSinglePersonFee(terminDate,dateInLoop,addFeeMonths,memberID,memberObj) {
        let counterCheck = 0;
        const selectedMonth = this.fund.month;
        const selectedYear = this.fund.year;
                    for (let ind = 0; ind <= addFeeMonths - 1; ind++) {
                        this.fundCollectiveInvoice[ind] = new IMemberFeeDetails;
                        counterCheck = counterCheck + 1;

                        terminDate = new Date(memberObj.settings.dueDate);

                        dateInLoop = new Date(memberObj.settings.dueDate);
                        dateInLoop.setDate(1);
                        dateInLoop.setMonth(terminDate.getMonth() + ind);
                        const feeBase = this.isTrainerFee()
                            ? this.trainerGrossFee()
                            : (Number(this.fund.pay) || 0);
                        this.fundInvoice.pay = this.isTrainerFee() ? feeBase : this.fund.pay;
                        this.fundInvoice.tax = (feeBase - this.discountAmount / addFeeMonths) * this.taxRate / 100.0;
                        this.fundCollectiveInvoice[ind].pay = this.fund.pay;
                        this.fundCollectiveInvoice[ind].tax = (this.fund.pay * this.taxRate) / 100.0;
                        var paydate: any = this.datePipe.transform(
                            this.fund.date,
                            "MM/dd/yyyy,  h:mm a"
                        );
                        this.fund.date = paydate;
                        if (!this.isTrainerFee()) {
                            this.fund.day = new Date(memberObj.settings.dueDate).getDate().toString();
                        }
                        if(this.isDiscountFormulaReverse){
                            this.fund.tax = (this.discountAmount == feeBase)? 0: parseFloat(  ((feeBase  / addFeeMonths) * this.taxRate / 100).toFixed(2));
                        }else {
                            this.fund.tax = parseFloat(((feeBase - this.discountAmount / addFeeMonths) * this.taxRate / 100.0).toFixed(2));
                        }
                        this.fundInvoice.day = new Date(this.fund.dueDate).getDate().toString();
                        if(this.durationType != "months"){
                            this.fundInvoice.day = new Date(memberObj.settings.dueDate).getDate().toString();
                        }
                        this.fundCollectiveInvoice[ind].day = new Date(this.fund.dueDate).getDate().toString();
                        if(this.durationType != "months"){
                            this.fundCollectiveInvoice[ind].day  = new Date(memberObj.settings.dueDate).getDate().toString();
                        }
                        this.fundInvoice.month = this.fund.month;
                        this.fundInvoice.year = this.fund.year;
                        if (this.fund.status == "Monthly Fee - Paid") {
                            this.fundInvoice.discount = this.discountAmount ;
                            this.fund.discount = parseFloat((this.discountAmount ).toFixed(2));

                        }
                        else {
                            this.fundInvoice.discount = this.discountAmount;
                            this.fund.discount = this.discountAmount;

                        }
                        this.fundInvoice.status = this.fund.status;
                        this.fundCollectiveInvoice[ind].month = this.fund.month;
                        this.fundCollectiveInvoice[ind].year = this.fund.year;
                        this.fundCollectiveInvoice[ind].status = this.fund.status;
                        this.fund.memberId = memberID;
                        this.fundInvoice.description = this.fund.description;
                        this.fundCollectiveInvoice[ind].description = this.fund.description;
                        this.fund.isDelete = memberObj.isDelete;
                        this.fund.isSynced = memberObj.isSynced;
                        this.fund.isDefaulter = memberObj.isDefaulter;
                        this.fund.type = 'Add Fee';
                        this.fund.scope = 'Member';
                        this.fund.initiatedFrom = 'Add Member';
                        this.fund.currentUserData = this.currentUserData;
                        this.fund.oldDate = memberObj.oldDate;
                        this.fund.previousDueDate = this.fund.oldDate ?? this.previousDueDate;
                        this.fund.nextDueDate = this.fund.dueDate;
                        this.fund.createdBy = this.currentUserData.name;
                        this.fund.noOfMonths = this.numOfMonths;
                        const startMonth =
                            this.fund.status === 'Monthly Fee - Paid'
                                ? selectedMonth
                                : new Date(memberObj.settings.dueDate).getMonth() + 1;
                        const startYear =
                            this.fund.status === 'Monthly Fee - Paid'
                                ? selectedYear
                                : new Date(memberObj.settings.dueDate).getFullYear();
                        const dueMonth = startMonth + this.fund.noOfMonths;
                        this.fund.months = [];
                        this.fund.years = [];
                        let currentPayMonth = startMonth;
                        let currentPayYear = startYear;
                        while (currentPayMonth < dueMonth) {
                            let month = ((currentPayMonth - 1) % 12) + 1;
                            if (month === 0) {
                                month = 12;
                            }
                            this.fund.years.push(currentPayYear.toString());
                            this.fund.months.push(month.toString());
                            if (month === 12) {
                                currentPayYear++;
                            }
                          currentPayMonth++;
                        }
                        const currentDate = new Date();
                        const currentMonth = currentDate.getMonth() + 1;
                        const currentYear = currentDate.getFullYear();
                        this.fund.invoice = AppUtils.generateInvoiceNo(memberObj.tagNumber,this.customerFees, currentYear, currentMonth, false, counterCheck);
                        if (this.fund.status === 'Monthly Fee - Paid') {
                            if (addFeeMonths === 1) {
                                this.fund.month = selectedMonth;
                                this.fund.year = selectedYear;
                            } else {
                                const monthOffset = selectedMonth - 1 + ind;
                                this.fund.month = (monthOffset % 12) + 1;
                                this.fund.year = selectedYear + Math.floor(monthOffset / 12);
                            }
                        } else {
                            let lastDayOfMonthInLoop: any = new Date(dateInLoop.getFullYear(), dateInLoop.getMonth() + 1, 0);
                            if (lastDayOfMonthInLoop.getDate() < terminDate.getDate()) {
                                this.fund.day = lastDayOfMonthInLoop.getDate();
                                this.fund.month = dateInLoop.getMonth() + 1;
                                this.fund.year = dateInLoop.getFullYear();
                            }
                            else {
                                terminDate.setMonth(terminDate.getMonth() + ind);
                                this.fund.day = this.fund.day;
                                this.fund.month = terminDate.getMonth() + 1;
                                this.fund.year = terminDate.getFullYear();
                            }
                        }
                        this.fund.date = new Date();
                        this.fund.paymentMode = this.paymentMode;
                        this.fund.dueDateAfterApproval = this.fund.dueDate;
                        this.fund.nextDueDate = this.fund.dueDateAfterApproval ?? this.fund.dueDate;
                        this.fund.isApproved = true;
                        if(this.branch.businessRule == true){
                            if(this.businessRules.businessRule == "FEEAPPROVALADMIN"){
                                let futureDate = moment(this.member.settings.dueDate).add(this.businessRules.gracePeriodForApproval, 'days').toISOString();
                                this.fund.dueDateAfterApproval = this.fund.dueDate;
                                this.fund.dueDate = new Date(futureDate);
                                this.fund.isApproved = false;
                            }
                        }
                        if (this.selectedFile) {
                            const formData: FormData = new FormData();
                            formData.append('feeReceiptImage', this.selectedFile, this.selectedFile.name);
                            try {
                                await this.uploadReceipt(formData);
                                this.fund.feeReceiptImageUrl = this.selectedFileName;
                            } catch (error) { }
                        }
                        //this.fundCollectiveInvoice[ind]=this.fundInvoice;
                        this.fundInvoice.invoice = this.fund.invoice;
                        if (ind === 0) {
                            this.fundCollectiveInvoice[ind].invoice = this.fund.invoice;
                            this.firstInvoice = this.fund.invoice;
                        }
                        if (this.fund.status == "Trainer Fee - Paid") {
                            this.stampShortenedBillingOnFund();
                            this.fund.remainingSessionCount = parseInt(this.trainerSessions);
                            this.fund.sessionCount = this.trainerSessions;
                            this.fund.gymSharePercentage= this.gymSharePercentage;
                            this.fund.trainerSharePercentage= this.trainerSharePercentage;
                            const shareBase = this.trainerCollectedPay();
                            if(this.fund.type=="WITH_TAX'"){
                            this.fund.gymShare= (((shareBase + this.fund.tax)  * this.gymSharePercentage) / 100).toString();
                            this.fund.trainerShare= (((shareBase + this.fund.tax)    * this.trainerSharePercentage) / 100).toString();
                            }else{
                            this.fund.gymShare= ((shareBase * this.gymSharePercentage) / 100).toString();
                            this.fund.trainerShare= ((shareBase * this.trainerSharePercentage) / 100).toString();
                            }

                            this.fund.trainerName= memberObj.customerstrainer.name;
                            const url = `trainingAttendance/updateSessionCount/${memberObj._id}`;
                            const body = { sessionCount: this.trainerSessions, flag: true };
                            this.appServiceManager.put(url, body).subscribe((res: any) => {
                                console.log('Update successful', res);
                            },
                                (error) => {
                                    // Handle the error
                                    console.error('Update failed', error);
                                }
                            );
                        }

                        if(addFeeMonths == 1) {
                            this.singleInvoicePrint.memberId = memberObj._id;
                            this.singleInvoicePrint.phone = memberObj.contactDetail.contact;
                            this.singleInvoicePrint.companyLogo = this.company.bannerImage;
                            this.singleInvoicePrint.branchName = this.branch.name;
                            this.singleInvoicePrint.branchAddress = this.branch.address;
                            this.singleInvoicePrint.branchPhone = this.branch.phone;
                            this.singleInvoicePrint.invoice = this.fund.invoice;
                            this.singleInvoicePrint.date = this.fund.date;
                            this.singleInvoicePrint.day =  this.fund.day;
                            this.singleInvoicePrint.month =  this.fund.month;
                            this.singleInvoicePrint.year =  this.fund.year;
                            this.singleInvoicePrint.dueDate =  this.fund.dueDate;
                            if(this.branch.businessRule == true){
                                if(this.businessRules.businessRule == "FEEAPPROVALADMIN"){
                                    this.singleInvoicePrint.dueDate =  this.fund.dueDateAfterApproval;

                                }
                            }
                            this.stampInvoicePeriodOnPrint(this.singleInvoicePrint);
                            this.singleInvoicePrint.memberTagNumber = memberObj.tagNumber;
                            this.singleInvoicePrint.memberName = memberObj.name;
                            this.singleInvoicePrint.memberPackageId = memberObj.packageId;
                            this.singleInvoicePrint.feeStatus =  this.fund.status;
                            this.singleInvoicePrint.feeAmount =  this.receiptFeeAmount();
                            this.singleInvoicePrint.balance= this.fund.remainingBalance;
                            this.singleInvoicePrint.taxOnFee =  this.fund.tax;
                            this.singleInvoicePrint.discountOnFee =  this.fund.discount;
                            if (this.numberOfMemberFeeToBePaid > 1) {
                                this.savedFeesToBePrint.push({...this.singleInvoicePrint});
                            }
                        }
                        else if(addFeeMonths > 1){
                            console.info("this.existingFeesInSavedFees ::BEFORE:: ", ind, this.savedFeesToBePrint);
                            const existingFeesInSavedFees = this.savedFeesToBePrint.filter(f => f.memberId == memberObj._id);
                            if(existingFeesInSavedFees.length > 0) {
                                const feeData = {
                                    memberTagNumber : memberObj.tagNumber,
                                    memberName : memberObj.name,
                                    feeStatus : this.fund.status,
                                    feeAmount : this.fund.pay,
                                    taxOnFee : this.fund.tax,
                                    discountOnFee : this.fund.discount,
                                    balance: this.fund.remainingBalance,
                                };
                                existingFeesInSavedFees[0].monthFees.push({...feeData});
                            }
                            else {
                                this.multiMonthInvoicePrint = {
                                    memberId:"",
                                    phone:"",
                                    memberTagNumber: "",
                                    memberPackageId: "",
                                    memberName: "",
                                    companyLogo: "",
                                    branchName: "",
                                    branchAddress: "",
                                    branchPhone: "",
                                    invoice: "",
                                    date: new Date(),
                                    day: "",
                                    month: 0,
                                    year: 0,
                                    dueDate: new Date(),
                                    monthFees : []
                                };
                                this.multiMonthInvoicePrint.memberId = memberObj._id;
                                this.multiMonthInvoicePrint.phone = memberObj.contactDetail.contact;
                                this.multiMonthInvoicePrint.memberName = memberObj.name;
                                this.multiMonthInvoicePrint.memberTagNumber = memberObj.tagNumber;
                                this.multiMonthInvoicePrint.memberPackageId = memberObj.packageId;
                                this.multiMonthInvoicePrint.companyLogo = this.company.bannerImage;
                                this.multiMonthInvoicePrint.branchName = this.branch.name;
                                this.multiMonthInvoicePrint.branchAddress = this.branch.address;
                                this.multiMonthInvoicePrint.branchPhone = this.branch.phone;
                                this.multiMonthInvoicePrint.invoice = this.fund.invoice;
                                this.multiMonthInvoicePrint.date = this.fund.date;
                                this.multiMonthInvoicePrint.day =  this.fund.day;
                                this.multiMonthInvoicePrint.month =  this.fund.month;
                                this.multiMonthInvoicePrint.year =  this.fund.year;
                                this.multiMonthInvoicePrint.dueDate =  this.fund.dueDate;
                                if(this.branch.businessRule == true){
                                    if(this.businessRules.businessRule == "FEEAPPROVALADMIN"){
                                        this.multiMonthInvoicePrint.dueDate =  this.fund.dueDateAfterApproval;

                                    }
                                }
                                this.stampInvoicePeriodOnPrint(this.multiMonthInvoicePrint);
                                const feeData = {
                                    memberTagNumber : memberObj.tagNumber,
                                    memberName : memberObj.name,
                                    feeStatus : this.fund.status,
                                    feeAmount : this.fund.pay,
                                    balance: this.fund.remainingBalance,
                                    taxOnFee : this.fund.tax,
                                    discountOnFee : this.fund.discount
                                };
                                this.multiMonthInvoicePrint.monthFees.push({...feeData});
                                this.savedFeesToBePrint.push({...this.multiMonthInvoicePrint});
                            }
                            console.info("this.existingFeesInSavedFees ::AFTER:: ", ind, this.savedFeesToBePrint);
                        }
                        this.fund.walletAmountPaid = this.isTrainerFee() ? false : this.walletAmountPaid;
                        if (this.isTrainerFee()) {
                            this.fund.walletAmountUsed = 0;
                            this.fund.payAdvance = this.payAdvance;
                            this.fund.payNewPeriod = false;
                        }
                        this.fund.totalFeePaid = this.totalFeePaid;
                        if (this.isSecondaryFeeSelected()) {
                            this.fund.isSecondaryPackageFee = true;
                            this.fund.packageId = this.selectedFeePackageId;
                            this.fund.packageName = this.fund.packageName
                                || ((this.member?.secondaryPackages || []).find(
                                    (p) => String(p.packageId) === String(this.selectedFeePackageId),
                                ) || {}).packageName;
                            this.fund.payAdvance = false;
                            this.fund.payNewPeriod = false;
                            this.fund.walletAmountUsed = 0;
                            this.fund.walletAmountPaid = false;
                            this.fund.sameHistoryGroupPayment = false;
                        } else if (this.fund.status === 'Monthly Fee - Paid') {
                            this.fund.payAdvance = this.payNewPeriod ? false : this.payAdvance;
                            this.fund.payNewPeriod =
                                this.payNewPeriod &&
                                !this.payNewPeriodBlockedMessage &&
                                this.numberOfMemberFeeToBePaid <= 1;
                            this.fund.isSecondaryPackageFee = false;
                            if (
                                this.isSameHistoryActive() &&
                                this.numberOfMemberFeeToBePaid > 1
                            ) {
                                this.fund.sameHistoryGroupPayment = true;
                            }
                            if (this.walletAmountUsedInput > 0) {
                                this.fund.walletAmountUsed = this.walletAmountUsedInput;
                            }
                        }
                        this.fund.taxRate = this.taxRate;
                        this.stampShortenedBillingOnFund();
                        memberObj.freezeDetail.totalFreezingDays = this.resetTotalFreezingDays;
                        console.log("TRAINER FEE CHECK", {
                            originalFee: this.trainerGrossFee(),
                            savedFee: this.fund.pay,
                            discount: this.fund.discount,
                            totalFeePaid: this.fund.totalFeePaid
                        });
                        // Keep the original trainer fee in the saved record.
// Discount remains stored separately.

                        let reqBody ={
                            customer : memberObj,
                            fund : this.fund
                        }
                        memberObj.feeDetails.push({ ...this.fund });
                        // Multiple Payment Modes: route through pay-fund-split
                        // (one API call; backend creates one row per mode).
                        if (this.shouldUseSplitPayment()) {
                            this.submitSplitPayment(memberObj);
                            return;
                        }
                        this.appServiceManager
                            .post(
                                "branches/" + this.user.branch + "/customers/actions/pay-fund",
                                reqBody
                            )
                            .subscribe(
                                async (res: any) => {
                                    let flag = false;
                                    if (res.status) {
                                        this.responseCount++;
                                        if (addFeeMonths == 1) {
                                            if(this.numberOfMemberFeeToBePaid == 1) {
                                                // Backend saved the fee and posted SRB / FBR before replying;
                                                // the ids ride on res.fee, so no second lookup is needed.
                                                this.setTaxInvoiceIdsFromFee(res.fee);
                                                await this.printInvoice(this.singleInvoicePrint);
                                                this.messageService.clear();
                                                this.messageService.add({
                                                    severity: "success",
                                                    summary: "Success Message",
                                                    detail: "Member Fee Submitted",
                                                });
                                                this.isFeeSubmitting = false;
                                                this.closeFeeCollectionDialog.emit();
                                            }
                                            else if (this.numberOfMemberFeeToBePaid > 1) {
                                                if(this.numberOfMemberFeeToBePaid == this.responseCount) {
                                                    setTimeout(() => {
                                                        this.printGroupInvoice(this.savedFeesToBePrint);
                                                        this.messageService.clear();
                                                        this.messageService.add({
                                                            severity: "success",
                                                            summary: "Success Message",
                                                            detail: "Member Fee Submitted",
                                                        });
                                                        this.responseCount = 0;
                                                        this.isFeeSubmitting = false;
                                                        this.closeFeeCollectionDialog.emit();
                                                    }, 1000);
                                                }
                                            }

                                            flag = true;
                                        }
                                        if (ind == addFeeMonths - 1 && flag === false) {
                                            if(this.numberOfMemberFeeToBePaid == 1) {
                                                console.log("customers/payFund :: RESPONSE SUCCESS :: MULTI MONTH SINGLE MEMBER");
                                                console.log("customers/payFund :: RESPONSE SUCCESS :: printMultipleInvoices()", this.numberOfMemberFeeToBePaid,this.multiMonthInvoicePrint);
                                                console.log("customers/payFund :: RESPONSE SUCCESS :: printMultipleInvoices() CHECK :: ", (this.numberOfMemberFeeToBePaid * addFeeMonths) == this.responseCount, this.numberOfMemberFeeToBePaid, addFeeMonths, this.responseCount);
                                                if((this.numberOfMemberFeeToBePaid * addFeeMonths) == this.responseCount) {
                                                    this.printMultipleInvoices(this.multiMonthInvoicePrint);
                                                    this.isFeeSubmitting = false;
                                                    this.closeFeeCollectionDialog.emit();
                                                }
                                            }
                                            else if (this.numberOfMemberFeeToBePaid > 1) {
                                                console.log("customers/payFund :: RESPONSE SUCCESS :: MULTI MONTH MULTI MEMBER");
                                                console.log("customers/payFund :: RESPONSE SUCCESS :: ALL MEMBERS TOTAL MONTHS. ", (this.numberOfMemberFeeToBePaid * addFeeMonths));
                                                if((this.numberOfMemberFeeToBePaid * addFeeMonths) == this.responseCount) {
                                                    console.log("customers/payFund :: RESPONSE SUCCESS :: printGroupMultipleInvoices()", (this.numberOfMemberFeeToBePaid * addFeeMonths),this.responseCount,this.savedFeesToBePrint);
                                                    this.printGroupMultipleInvoices(this.savedFeesToBePrint);
                                                    this.responseCount = 0;
                                                    this.isFeeSubmitting = false;
                                                    this.closeFeeCollectionDialog.emit();
                                                }
                                            }
                                            this.messageService.clear();
                                            this.messageService.add({
                                                severity: "success",
                                                summary: "Success Message",
                                                detail: "Member Fee Submitted",
                                            });
                                        }
                                        this.dataService.refreshDefaulter("refreshDefaulters");
                                        if (memberObj.isDelete || memberObj.freezeDetail.isFreeze) {
                                            this.showActiceFreezeBox = true;
                                        }

                                    } else if (res.status == false) {
                                        this.isFeeSubmitting = false;
                                        this.messageService.clear();
                                        this.messageService.add({
                                            severity: "error",
                                            summary: "Info Message",
                                            detail: formatApiErrorDetail(null, 'Failed to save fee', res.error),
                                        });
                                    } else {
                                        this.isFeeSubmitting = false;
                                        this.messageService.clear();
                                        this.messageService.add({
                                            severity: "info",
                                            summary: "Info Message",
                                            detail: "Something Went Wrong",
                                        });
                                    }
                                },
                                (error) => {
                                    this.isFeeSubmitting = false;
                                    this.messageService.clear();
                                    this.messageService.add({
                                        severity: "error",
                                        summary: "Error Message",
                                        detail: formatApiErrorDetail(error),
                                    });
                                }
                            );
                    }
    }

    validateMember(res) {
        if (
            this.member.settings === null ||
            this.member.settings === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = null;
        } else if (
            this.member.settings.dueDate === null ||
            this.member.settings.dueDate === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = null;
        } else if (res.settings.dueDate === "null") {
            this.member.settings.dueDate = null;
        } else {
            const iso = asDateString(res.settings.dueDate);
            this.member.settings.dueDate = iso ? new Date(iso) : null;
        }
        if (
            this.member.customerstrainer === undefined ||
            this.member.customerstrainer === null
        ) {
            this.member.customerstrainer = new Customerstrainer();
            this.member.customerstrainer.name = "";
            this.member.customerstrainer.trainerId = "";
            this.member.customerstrainer.totalFees = "";
        }
        if (
            this.member.emergencyContact === null ||
            this.member.emergencyContact === undefined
        ) {
            this.member.emergencyContact = new IMemberEmergencyContact();
        }
        if (this.member.contactDetail.address) {
            if (
                this.member.contactDetail.address.street === null &&
                this.member.contactDetail.address.street === ""
            ) {
                this.member.contactDetail.address.street = "";
            }
            if (
                this.member.contactDetail.address.city === null &&
                this.member.contactDetail.address.city === ""
            ) {
                this.member.contactDetail.address.city = "";
            }
            if (
                this.member.contactDetail.address.country === null &&
                this.member.contactDetail.address.country === ""
            ) {
                this.member.contactDetail.address.country = "";
            }
            if (
                this.member.contactDetail.address.state === null &&
                this.member.contactDetail.address.state === ""
            ) {
                this.member.contactDetail.address.state = "";
            }
            if (
                this.member.contactDetail.address.zipCode === null &&
                this.member.contactDetail.address.zipCode === ""
            ) {
                this.member.contactDetail.address.zipCode = "";
            }
            if (
                this.member.contactDetail.address.town === null &&
                this.member.contactDetail.address.town === ""
            ) {
                this.member.contactDetail.address.town = "";
            }
        } else {
            this.member.contactDetail.address = new IAddress();
        }
    }

    updatePackage(showDialog) {

        const selectedPackagename = this.packagesDropDown.find(package1 => package1.value === this.member.packageId);
        this.isDialogVisible = showDialog;
        this.isFeeMessageVisible = showDialog;
        this.confirmationService.confirm({
            message: "Are you sure you want to update package?",
            accept: () => {
                let packageMonths = 0;
                let selectedPackage: IPackageBuider = this.packages.find(x => x._id === this.member.packageId)
                // Month Wise Package: per Month Fee and whole package fee.
                if (
                    selectedPackage.packageType === "Month Wise Package" &&
                    selectedPackage.packageFeeType === "whole package fee"
                ) {
                    packageMonths = selectedPackage.noOfMonths;
                    this.member.monthFee = Math.round(
                        selectedPackage.packageFee
                    ).toString();
                } else if (
                    selectedPackage.packageType === "Month Wise Package" &&
                    selectedPackage.packageFeeType === "per Month Fee"
                ) {
                    packageMonths = selectedPackage.noOfMonths;
                    this.member.monthFee = Math.round(
                        selectedPackage.packageFee
                    ).toString();
                }
                // Person Wise Package: per person Fee and whole package fee.
                else if (
                    selectedPackage.packageType === "Person Wise Package" &&
                    selectedPackage.packageFeeType === "whole package fee"
                ) {
                    packageMonths = selectedPackage.noOfMonths;
                    this.member.monthFee = Math.round(
                        selectedPackage.packageFee / selectedPackage.noOfMembers
                    ).toString();
                } else if (
                    selectedPackage.packageType === "Person Wise Package" &&
                    selectedPackage.packageFeeType === "per Person Fee"
                ) {
                    packageMonths = selectedPackage.noOfMonths;
                    this.member.monthFee = Math.round(
                        selectedPackage.packageFee / packageMonths
                    ).toString();

                } else {
                    packageMonths = selectedPackage.noOfMonths;
                    this.member.monthFee = Math.round(
                        selectedPackage.packageFee / packageMonths
                    ).toString();
                }

                this.member.registerationFee = this.packages.find(x => x._id === this.member.packageId).registerationFee !== undefined ? this.packages.find(x => x._id === this.member.packageId).registerationFee.toString() : "0";
                this.member.company = this.user.company;
                this.member.branch = this.user.branch;
                this.member.type = 'Update Package';
                this.member.scope = 'Member';
                this.member.initiatedFrom = 'Add Member';
                this.updateMemberSettingFlag = true;
                this.member.memberSettingFlag = this.updateMemberSettingFlag;
                this.member.packageName = selectedPackagename.label;
                const packagePayload = buildMemberUpdatePayload(this.member, {
                    modifiedBy: this.currentUserData?.name,
                    type: 'Update Package',
                    includeCompanyBranch: true,
                });
                this.appServiceManager
                    .put(customerUpdateUrl(this.user.branch, this.member._id), packagePayload)
                    .subscribe(
                        (res: any) => {
                            if (res) {
                                this.member = res.customer;
                                this.feeDetailsSource = JSON.stringify(
                                    this.member.feeDetails
                                );
                                this.validateMember(res.customer);
                                this.fund.pay = parseInt(
                                    this.member.monthFee
                                );
                                this.setDate(res.customer);
                                this.getCompany();
                                this.calculateTotal();
                                this.allowDialog = true;
                                this.loadPackages();
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success Message",
                                    detail: "Member Successfully Updated",
                                });
                            } else {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Info Message",
                                    detail: "Something Went Wrong",
                                });
                            }
                        },
                        (error) => {
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: formatApiErrorDetail(error),
                            });
                        },
                        this.updateMemberSettingFlag = false
                    );
            },
        });
        // }
    }

    setDate(res) {
        if (
            res.dateOfBirth === "null" ||
            res.dateOfBirth === null ||
            res.dateOfBirth === undefined
        ) {
            this.member.dateOfBirth = null;
        } else {
            var dateOfBirth = JSON.stringify(res.dateOfBirth);
            var DOB = JSON.parse(dateOfBirth).split("/");
            if (DOB.length === 1) {
                this.member.dateOfBirth = new Date(DOB);
            } else {
                var newDOBDate = DOB[1] + "/" + DOB[0] + "/" + DOB[2];
                if (newDOBDate) {
                    this.member.dateOfBirth = new Date(newDOBDate);
                }
            }
        }
        if (
            res.joiningDate === "null" ||
            res.joiningDate === null ||
            res.joiningDate === undefined
        ) {
            this.member.joiningDate = null;
        } else {
            var joiningDate = JSON.stringify(res.joiningDate);
            var JD = JSON.parse(joiningDate).split("/");
            if (JD.length === 1) {
                this.member.joiningDate = new Date(JD);
            } else {
                var newJDate = JD[1] + "/" + JD[0] + "/" + JD[2];
                if (newJDate) {
                    this.member.joiningDate = new Date(newJDate);
                }
            }
        }
        if (
            !res.customerstrainer ||
            res.customerstrainer.dueDate === "" ||
            res.customerstrainer.dueDate === "null" ||
            res.customerstrainer.dueDate === null ||
            res.customerstrainer.dueDate === undefined
        ) {
            this.member.customerstrainer.dueDate = null;
        } else {
            const iso = asDateString(res.customerstrainer.dueDate);
            this.member.customerstrainer.dueDate = iso ? new Date(iso) : null;
        }
    }

    onUploadButtonClick(): void {
        const fileInput = document.getElementById('fileInput') as HTMLInputElement;
        fileInput.click();
    }

    calculateTotal() {
        this.feeTotal = 0;
        this.feeTotalDiscount = 0;
        if (this.member.feeDetails) {
            if (this.member.feeDetails.length > 0) {
                this.member.feeDetails.forEach((record) => {
                    const pay = record.pay != null ? parseInt(String(record.pay), 10) : 0;
                    this.feeTotal += isNaN(pay) ? 0 : pay;
                    if (record.discount != null) {
                        const discount = parseInt(String(record.discount), 10);
                        this.feeTotalDiscount += isNaN(discount) ? 0 : discount;
                    }
                });
            }
        }
    }

    checkWalletBalance(isChecked: boolean) {
        this.walletAmountPaid = isChecked
        const data = {
            customerId: this.memberID,
            fee: this.totalFeePaid
        };
        if (isChecked) {
            this.appServiceManager.post(walletCheckBalanceUrl(this.user.branch), data).subscribe(
                (res: any) => {

                    const status = res.data.status;
                    const walletAmount = res.data.walletAmount;

                    if (!res.success) {
                        this.walletMessage = `Available Wallet Balance: ${walletAmount}. Insufficient for fee.`;
                        this.walletStatusClass = "wallet-red";
                        return;
                    }

                    if (!status) {
                        this.walletMessage = `Available Wallet Balance: ${walletAmount}. Insufficient for fee.`;
                        this.walletStatusClass = "wallet-red";
                    } else {
                        this.walletMessage = `Sufficient Wallet Balance: ${walletAmount}`;
                        this.walletStatusClass = "wallet-green";
                    }
                },
                (error) => {
                    this.walletMessage = "Error checking wallet!";
                    this.walletStatusClass = "wallet-red";
                }
            );
        } else {
            this.walletMessage = "Deduct from wallet";
            this.walletStatusClass = "wallet-Black";
        }
    }


    // hotClicky($event) {
    //     let currentClickLocation = $event.target.id;
    //     let indexOfClickField = this.enterSteps.indexOf(currentClickLocation);
    //     if (indexOfClickField !== -1) {
    //       this.currentStep = indexOfClickField;
    //     }
    //   }

    hasPrintDiscount(discount: number): boolean {
        return +(discount || 0) > 0;
    }

    hasPrintTax(): boolean {
        return this.taxType !== 'NO_TAX';
    }

    getPrintSubtotalLabelColspan(discount: number): number {
        return this.hasPrintDiscount(discount) || this.hasPrintTax() ? 4 : 3;
    }

    getPrintSubtotalValueColspan(discount: number): number {
        const extra = (this.hasPrintDiscount(discount) ? 1 : 0) + (this.hasPrintTax() ? 1 : 0);
        return extra || 1;
    }

    getPrintMonthlySubtotalLabelColspan(discount: number): number {
        const totalCols = 4
            + (this.hasPrintDiscount(discount) ? 1 : 0)
            + (this.hasPrintTax() ? 1 : 0);
        return totalCols - this.getPrintSubtotalValueColspan(discount) - 1;
    }

    printMultipleInvoices(data): void {
        console.log("printMultipleInvoices()", data);
        const CreatedLabel = this.setLabel("CreatedLabel");
        const dueDateLabel = this.setLabel("dueDateLabel");
        const nextDueLabel = this.setLabel("nextDueLabel");
        const memberShipNoLabel = this.setLabel("m#Label");
        const nameLabel = this.setLabel("nameLabel");
        const typeLabel = this.setLabel("typeLabel");
        const amountLabel = this.setLabel("amountLabel");
        const discountLabel = this.setLabel("discountLabel");
        const taxLabel = this.setLabel("taxLabel");
        const subTotalLabel = this.setLabel("subTotalLabel");
        const softwareProvidedByTecfolkLabel = this.setLabel("softwareProvidedByTecfolkLabel");
        const printData = data;
        const currentDate = new Date();
        const date = new Date(printData.date).toLocaleDateString();
        const { periodStartLabel, periodEndLabel } = this.getPrintInvoicePeriodLabels(printData);
        const title = this.branch.name+ " " + currentDate.getDate()+ "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
        const companyLogo = printData.companyLogo ? this.config.Server + 'assets/layout/images/companies/' + printData.companyLogo : 'assets/layout/images/logoCompany.png';
        let monthsData = "";
        let totalFeeAmount = 0;
        let totalFeeTax = 0;
        let totalFeeDiscount = 0;
        for (let i = 0; i < printData.monthFees.length; i++) {
            const monthTr = `
                <tr>
                    <td style="
                            font-size: 9px;
                            border: 1px solid black;
                            text-align: center;
                        ">
                        ${printData.monthFees[i].memberTagNumber}
                    </td>
                    <td style="
                            font-size: 9px;
                            border: 1px solid black;
                            text-align: center;
                        ">
                        ${printData.monthFees[i].memberName}
                    </td>
                    <td style="
                            font-size: 9px;
                            border: 1px solid black;
                            text-align: center;
                        ">
                        ${printData.monthFees[i].feeStatus}
                    </td>
                    <td style="
                            font-size: 9px;
                            border: 1px solid black;
                            text-align: center;
                        ">
                        ${printData.monthFees[i].feeAmount}
                    </td>
                    ${totalFeeDiscount > 0 ? `
                    <td style="
                            font-size: 9px;
                            border: 1px solid black;
                            text-align: center;
                        ">
                        ${printData.monthFees[i].discountOnFee}
                    </td>` : ''}
                    ${this.hasPrintTax() ? `<td style="
                            font-size: 9px;
                            border: 1px solid black;
                            text-align: center;
                        ">
                        ${printData.monthFees[i].taxOnFee}
                    </td>` : ''}
                </tr>
            `;
            monthsData += monthTr;
            totalFeeAmount += printData.monthFees[i].feeAmount;
            totalFeeTax += printData.monthFees[i].taxOnFee || 0;
            totalFeeDiscount += printData.monthFees[i].discountOnFee;
            }

        let taxMessage = "";
        if(this.taxType === 'INCLUDING_TAX') {
            taxMessage = totalFeeTax + " " + this.setLabel("taxIncludedFeeLabel");
        }
        let grandTotal = 0;
        if(this.taxType == 'WITH_TAX') {
            grandTotal = ((totalFeeAmount - totalFeeDiscount) || 0) + (totalFeeTax || 0);
        }
        else if(this.taxType != 'WITH_TAX') {
            grandTotal = totalFeeAmount - totalFeeDiscount;
            }

        const printContents = `
            <div class="invoice-box" style="
                padding: 0px !important;
                width: 75mm;
                max-width: 75mm;
                margin: 0 !important;
                ">
                <div style="width: 57mm; max-width: 57mm; padding-left: 8px;">
                    <img src="${companyLogo}"
                        alt="Company Logo" style="
                            display: block;
                            margin-left: auto;
                            margin-right: auto;
                            width: 58%;
                            margin-top: 3px;
                            margin-bottom: 2px;
                        " />
                    <div style="
                            text-align: center;
                            font-size: 11px;
                            line-height: 14px;
                            color: black;
                        ">
                        ${ printData.branchName }
                    </div>
                    <div style="
                            text-align: center;
                            font-size: 11px;
                            line-height: 14px;
                            color: black;
                        ">
                        ${ printData.branchAddress }
                    </div>
                    <div style="
                            text-align: center;
                            font-size: 11px;
                            line-height: 15px;
                            color: black;
                        ">
                        ${ printData.branchPhone }
                    </div>
                    <table style="
                            border-collapse: collapse;
                            border: 1px solid black;
                            font-size: 12px;
                            font-size: 9px;
                            line-height: 12px;
                            margin-top: 8px;
                        ">
                        <tbody>
                            <tr>
                                <td style="
                                        font-size: 10px;
                                        text-align:center;
                                        padding: 0px;
                                        font-weight: bold;

                                    " colspan="2">
                                    ${ printData.invoice }
                                </td>
                                <td style="
                                        font-size: 10px;
                                        text-align: center;
                                        padding: 0px;
                                        font-weight: bold;
                                    ">
                                    ${CreatedLabel}
                                </td>
                                <td style="
                                        font-size: 10px;
                                        text-align: center;
                                        padding: 0px;
                                    ">
                                    ${ date }
                                </td>

                            </tr>
                            <tr>
                                <td style="
                                        font-size: 10px;
                                        text-align: center;
                                        padding: 0px;
                                        font-weight: bold;
                                    ">
                                    ${dueDateLabel}
                                </td>
                                <td style="
                                        font-size: 10px;
                                        text-align: center;
                                        padding: 0px;
                                    ">
                                    ${ periodStartLabel }
                                </td>
                                <td style="
                                        font-size: 10px;
                                        text-align: center;
                                        padding: 0px;
                                        font-weight: bold;
                                    ">
                                    ${nextDueLabel}
                                </td>
                                <td style="
                                        font-size: 10px;
                                        text-align: center;
                                        padding: 0px;
                                    ">
                                    ${ periodEndLabel }

                                </td>
                            </tr>

                        </tbody>
                    </table>

                    <table style="
                            border-collapse: collapse;
                            font-size: 12px;
                            font-size: 9px;
                            margin-top: 3px;
                            line-height: normal;
                        ">
                        <thead style="
                                border: 1px solid black;
                                text-align: center;
                                font-weight: bold;
                                font-size: 12px;
                                font-size: 9px;
                                background-color: black;
                                color: white;
                                border: 1px solid black;
                            ">
                            <tr style="background-color: black; color: white">
                                <th style="
                                        width: 40px;
                                        word-break: break-word;
                                        font-size: 10px;
                                    ">
                                    ${memberShipNoLabel}
                                </th>
                                <th style="
                                        width: 40px;
                                        word-break: break-word;
                                        font-size: 10px;
                                    ">
                                    ${nameLabel}
                                </th>

                                <th style="
                                        width: 40px;
                                        word-break: break-word;
                                        font-size: 10px;
                                    ">
                                    ${typeLabel}
                                </th>
                           <th style="width: 40px; font-size: 9px">${amountLabel}</th>
            ${totalFeeDiscount > 0 ? `<th style="width: 40px; font-size: 9px">${discountLabel}</th>` : ''}
                ${this.hasPrintTax() ? `<th style="width: 40px; font-size: 9px">${taxLabel}</th>` : ''}

                            </tr>
                        </thead>
                        <tbody>
                            ${monthsData}
                           <tr>
                                <td></td>
                                <td style="
                                        font-size: 10px;
                                        text-align: center;
                                        font-weight: bold;
                                        border-bottom: 1px solid;
                                        border-left: 1px solid;
                                    " colspan="${this.getPrintMonthlySubtotalLabelColspan(totalFeeDiscount)}">
                                    ${subTotalLabel}
                                </td>
                                <td style="
                                        font-size: 10px;
                                        text-align: center;
                                        border-right: 1px solid;
                                        border-bottom: 1px solid;
                                    " colspan="${this.getPrintSubtotalValueColspan(totalFeeDiscount)}">
                                    <span>
                                        ${grandTotal}
                                    </span>
                                    <i style="display: block; font-size: 12px;  color: blue;">
                                        ${taxMessage}
                                    </i>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div style="
                            text-align: center;
                            padding-top: 6px;
                            font-size: 10px;
                            font-weight: bold;
                            color: black;
                            white-space: nowrap;
                            margin-left: 33px;
                            width: 100%;
                        ">
                        ${softwareProvidedByTecfolkLabel}
                    </div>
                </div>
            </div>
        `;

        const printHtml = `
        <html>
        <head>
            <title>${title}</title>
            <style>
                .invoice-box {
                    max-width: 800px;
                    margin: auto;
                    padding: 30px;
                    border: 1px solid #eee;
                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                    font-size: 16px;
                    line-height: 24px;
                    font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                    color: #555;
                }

                .invoice-box table {
                    width: 100%;
                    line-height: inherit;
                    text-align: left;
                }

                .invoice-box table td {
                    padding: 5px;
                    vertical-align: top;
                }

                .invoice-box table tr td:nth-child(n + 2) {
                    text-align: right;
                }

                .invoice-box table tr.top table td.title {
                    font-size: 45px;
                    line-height: 45px;
                    color: #333;
                }

                .invoice-box table tr.heading td {
                    background: #eee;
                    border-bottom: 1px solid #ddd;
                    font-weight: bold;
                }

                .invoice-box table tr.details td {
                    padding-bottom: 20px;
                }

                .invoice-box table tr.item td {
                    border-bottom: 1px solid #eee;
                }
                .invoice-box table tr.item.last td {
                    border-bottom: none;
                }
                .invoice-box table tr.item input {
                    padding-left: 5px;
                }
                .invoice-box table tr.item td:first-child input {
                    margin-left: -5px;
                    width: 100%;
                }
                .invoice-box table tr.total td:nth-child(2) {
                    border-top: 2px solid #eee;
                    font-weight: bold;
                }
                .invoice-box input[type="number"] {
                    width: 60px;
                }
                .heading td {
                  font-size: 13px;
                }
                .item td {
                    font-size: 13px;
                }
                @media only screen and (max-width: 600px) {
                    .invoice-box table tr.top table td {
                        width: 100%;
                        display: block;
                        text-align: center;
                    }

                    .invoice-box table tr.information table td {
                        width: 100%;
                        display: block;
                        text-align: center;
                    }
                }
                .rtl {
                    direction: rtl;
                    font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                        sans-serif;
                }
                .rtl table {
                    text-align: right;
                }
                .rtl table tr td:nth-child(2) {
                    text-align: left;
                }
            </style>
        </head>
        <body>${printContents}</body>
        </html>
        `;
        const popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(printHtml);
        this.dialogVisibility = false;
    }

    printGroupMultipleInvoices(data): void {
        const CreatedLabel = this.setLabel("CreatedLabel");
        const dueDateLabel = this.setLabel("dueDateLabel");
        const nextDueLabel = this.setLabel("nextDueLabel");
        const memberShipNoLabel = this.setLabel("m#Label");
        const nameLabel = this.setLabel("nameLabel");
        const typeLabel = this.setLabel("typeLabel");
        const amountLabel = this.setLabel("amountLabel");
        const discountLabel = this.setLabel("discountLabel");
        const taxLabel = this.setLabel("taxLabel");
        const subTotalLabel = this.setLabel("subTotalLabel");
        const softwareProvidedByTecfolkLabel = this.setLabel("softwareProvidedByTecfolkLabel");
        console.info("this.printGroupMultipleInvoices ::AFTER:: ", data);
        const currentDate = new Date();
        const title = this.branch.name+ " " + currentDate.getDate()+ "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
        let allPrintContents = "";
        for (let index = 0; index < data.length; index++) {
            const printData = data[index];
            const date = new Date(printData.date).toLocaleDateString();
            const { periodStartLabel, periodEndLabel } = this.getPrintInvoicePeriodLabels(printData);
            const companyLogo = printData.companyLogo ? this.config.Server + 'assets/layout/images/companies/' + printData.companyLogo : 'assets/layout/images/logoCompany.png';
            let monthsData = "";
            let totalFeeAmount = 0;
            let totalFeeTax = 0;
            let totalFeeDiscount = 0;
            for (let i = 0; i < printData.monthFees.length; i++) {
                const monthTr = `
                    <tr>
                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${printData.monthFees[i].memberTagNumber}
                        </td>
                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${printData.monthFees[i].memberName}
                        </td>
                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${printData.monthFees[i].feeStatus}
                        </td>
                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${printData.monthFees[i].feeAmount}
                        </td>

                         ${totalFeeDiscount > 0 ? `<td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${printData.monthFees[i].discountOnFee}
                        </td>` : ''}
                            ${this.hasPrintTax() ? `<td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${printData.monthFees[i].taxOnFee}
                        </td>` : ''}
                    </tr>
                `;
                monthsData += monthTr;
                totalFeeAmount += printData.monthFees[i].feeAmount;
                totalFeeTax += printData.monthFees[i].taxOnFee || 0;
                totalFeeDiscount += printData.monthFees[i].discountOnFee;
            }

            let taxMessage = "";
            if(this.taxType === 'INCLUDING_TAX') {
                taxMessage = totalFeeTax + " " + this.setLabel("taxIncludedFeeLabel");
            }
            let grandTotal = 0;
            if(this.taxType == 'WITH_TAX') {
                grandTotal = ((totalFeeAmount - totalFeeDiscount) || 0) + (totalFeeTax || 0);
            }
            else if(this.taxType != 'WITH_TAX') {
                grandTotal = totalFeeAmount - totalFeeDiscount;
            }

            const printContents = `
                <div class="invoice-box" style="
                    padding: 0px !important;
                    width: 75mm;
                    max-width: 75mm;
                    margin: 0 !important;
                    ">
                    <div style="width: 57mm; max-width: 57mm; padding-left: 8px;">
                        <img src="${companyLogo}"
                            alt="Company Logo" style="
                                display: block;
                                margin-left: auto;
                                margin-right: auto;
                                width: 58%;
                                margin-top: 3px;
                                margin-bottom: 2px;
                            " />
                        <div style="
                                text-align: center;
                                font-size: 11px;
                                line-height: 14px;
                                color: black;
                            ">
                            ${ printData.branchName }
                        </div>
                        <div style="
                                text-align: center;
                                font-size: 11px;
                                line-height: 14px;
                                color: black;
                            ">
                            ${ printData.branchAddress }
                        </div>
                        <div style="
                                text-align: center;
                                font-size: 11px;
                                line-height: 15px;
                                color: black;
                            ">
                            ${ printData.branchPhone }
                        </div>
                        <table style="
                                border-collapse: collapse;
                                border: 1px solid black;
                                font-size: 12px;
                                font-size: 9px;
                                line-height: 12px;
                                margin-top: 8px;
                            ">
                            <tbody>
                                <tr>
                                    <td style="
                                            font-size: 10px;
                                            text-align:center;
                                            padding: 0px;
                                            font-weight: bold;

                                        " colspan="2">
                                        ${ printData.invoice }
                                    </td>
                                    <td style="
                                            font-size: 10px;
                                            text-align: center;
                                            padding: 0px;
                                            font-weight: bold;
                                        ">
                                        ${CreatedLabel}
                                    </td>
                                    <td style="
                                            font-size: 10px;
                                            text-align: center;
                                            padding: 0px;
                                        ">
                                        ${ date }
                                    </td>

                                </tr>
                                <tr>
                                    <td style="
                                            font-size: 10px;
                                            text-align: center;
                                            padding: 0px;
                                            font-weight: bold;
                                        ">
                                        ${dueDateLabel}
                                    </td>
                                    <td style="
                                            font-size: 10px;
                                            text-align: center;
                                            padding: 0px;
                                        ">
                                        ${ periodStartLabel }
                                    </td>
                                    <td style="
                                            font-size: 10px;
                                            text-align: center;
                                            padding: 0px;
                                            font-weight: bold;
                                        ">
                                        ${nextDueLabel}
                                    </td>
                                    <td style="
                                            font-size: 10px;
                                            text-align: center;
                                            padding: 0px;
                                        ">
                                        ${ periodEndLabel }

                                    </td>
                                </tr>

                            </tbody>
                        </table>

                        <table style="
                                border-collapse: collapse;
                                font-size: 12px;
                                font-size: 9px;
                                margin-top: 3px;
                                line-height: normal;
                            ">
                            <thead style="
                                    border: 1px solid black;
                                    text-align: center;
                                    font-weight: bold;
                                    font-size: 12px;
                                    font-size: 9px;
                                    background-color: black;
                                    color: white;
                                    border: 1px solid black;
                                ">
                                <tr style="background-color: black; color: white">
                                    <th style="
                                            width: 40px;
                                            word-break: break-word;
                                            font-size: 10px;
                                        ">
                                        ${memberShipNoLabel}
                                    </th>
                                    <th style="
                                            width: 40px;
                                            word-break: break-word;
                                            font-size: 10px;
                                        ">
                                        ${nameLabel}
                                    </th>

                                    <th style="
                                            width: 40px;
                                            word-break: break-word;
                                            font-size: 10px;
                                        ">
                                        ${typeLabel}
                                    </th>
                                    <th style="width: 40px; font-size: 9px">${amountLabel}</th>
                                  ${totalFeeDiscount > 0 ? `<th style="width: 40px; font-size: 9px">${discountLabel}</th>` : ''}
                                    ${this.hasPrintTax() ? `<th style="width: 40px; font-size: 9px">${taxLabel}</th>` : ''}

                                </tr>
                            </thead>
                            <tbody>
                                ${monthsData}
                                <tr>
                                    <td></td>
                                    <td style="
                                            font-size: 10px;
                                            text-align: center;
                                            font-weight: bold;
                                            border-bottom: 1px solid;
                                            border-left: 1px solid;
                                        " colspan="${this.getPrintMonthlySubtotalLabelColspan(totalFeeDiscount)}">
                                    ${subTotalLabel}
                                </td>
                                    <td style="
                                            font-size: 10px;
                                            text-align: center;
                                            border-right: 1px solid;
                                            border-bottom: 1px solid;
                                        " colspan="${this.getPrintSubtotalValueColspan(totalFeeDiscount)}">
                                        <span>
                                            ${grandTotal}
                                        </span>
                                        <i style="display: block; font-size: 12px;  color: blue;">
                                            ${taxMessage}
                                        </i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div style="
                                text-align: center;
                                padding-top: 6px;
                                font-size: 10px;
                                font-weight: bold;
                                color: black;
                                white-space: nowrap;
                                margin-left: 33px;
                                width: 100%;
                            ">
                            ${softwareProvidedByTecfolkLabel}
                        </div>
                    </div>
                </div>
            `;
            allPrintContents += printContents;
        }

        const printHtml = `
        <html>
        <head>
            <title>${title}</title>
            <style>
                .invoice-box {
                    max-width: 800px;
                    margin: auto;
                    padding: 30px;
                    border: 1px solid #eee;
                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                    font-size: 16px;
                    line-height: 24px;
                    font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                    color: #555;
                }

                .invoice-box table {
                    width: 100%;
                    line-height: inherit;
                    text-align: left;
                }

                .invoice-box table td {
                    padding: 5px;
                    vertical-align: top;
                }

                .invoice-box table tr td:nth-child(n + 2) {
                    text-align: right;
                }

                .invoice-box table tr.top table td.title {
                    font-size: 45px;
                    line-height: 45px;
                    color: #333;
                }

                .invoice-box table tr.heading td {
                    background: #eee;
                    border-bottom: 1px solid #ddd;
                    font-weight: bold;
                }

                .invoice-box table tr.details td {
                    padding-bottom: 20px;
                }

                .invoice-box table tr.item td {
                    border-bottom: 1px solid #eee;
                }
                .invoice-box table tr.item.last td {
                    border-bottom: none;
                }
                .invoice-box table tr.item input {
                    padding-left: 5px;
                }
                .invoice-box table tr.item td:first-child input {
                    margin-left: -5px;
                    width: 100%;
                }
                .invoice-box table tr.total td:nth-child(2) {
                    border-top: 2px solid #eee;
                    font-weight: bold;
                }
                .invoice-box input[type="number"] {
                    width: 60px;
                }
                .heading td {
                  font-size: 13px;
                }
                .item td {
                    font-size: 13px;
                }
                @media only screen and (max-width: 600px) {
                    .invoice-box table tr.top table td {
                        width: 100%;
                        display: block;
                        text-align: center;
                    }

                    .invoice-box table tr.information table td {
                        width: 100%;
                        display: block;
                        text-align: center;
                    }
                }
                .rtl {
                    direction: rtl;
                    font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                        sans-serif;
                }
                .rtl table {
                    text-align: right;
                }
                .rtl table tr td:nth-child(2) {
                    text-align: left;
                }
            </style>
        </head>
        <body>${allPrintContents}</body>
        </html>
        `;
        const popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(printHtml);
        this.dialogVisibility = false;
    }

    async  printInvoice(data): Promise<void> {
        let logoBlock = "";
        let contactBlock = "";
        const nameLabel = this.setLabel("nameLabel");
        const typeLabel = this.setLabel("typeLabel");
        const amountLabel = this.setLabel("amountLabel");
        const discountLabel = this.setLabel("discountLabel");
        const taxLabel = this.setLabel("taxLabel");
        const subTotalLabel = this.setLabel("subTotalLabel");
        const balanceRemainingLabel = this.setLabel("balanceRemainingLabel");
        const softwareProvidedByTecfolkLabel = this.setLabel("softwareProvidedByTecfolkLabel");
        const LabelLable = this.setLabel("m#Label");
        const currentDate=new Date();
        const printData = data;
        const user = this.user;
        const memberPackage = this.member.packageName;
        const paymentMode= this.fund.paymentMode;
        const paymentModeLines = parseSplitPaymentModeLines(paymentMode);
        const isMultiPaymentMode = paymentModeLines.length >= 2;
        const paymentModeHeader = getReceiptPaymentModeHeader(
            paymentMode,
            this.setLabel('multiplePaymentModesLabel'),
        );
        const paymentModeRowsHtml = isMultiPaymentMode
            ? paymentModeLines
                  .map(
                      (line) => `
                    <tr>
                       <td style="
        font-size: 10px;
        text-align: left;
        font-weight: bold;
        border-bottom: 1px solid;
        border-left: 1px solid;
    " colspan="${this.getPrintSubtotalLabelColspan(printData.discountOnFee)}">
    ${line.mode}
</td>
<td style="
        font-size: 10px;
        text-align: center;
        border-right: 1px solid;
        border-bottom: 1px solid;
    " colspan="${this.getPrintSubtotalValueColspan(printData.discountOnFee)}">
                            <span>
                                ${line.amountLabel}
                            </span>
                        </td>
                    </tr>`,
                  )
                  .join('')
            : '';
        const date = new Date(printData.date).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
        const { periodStartLabel: invoicePeriodStartLabel, periodEndLabel: invoicePeriodEndLabel } =
            this.getPrintInvoicePeriodLabels(printData);
        const title = this.branch.name+ " " + currentDate.getDate()+ "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
        //const companyLogo = printData.companyLogo ? this.config.Server + 'assets/layout/images/companies/' + printData.companyLogo : 'assets/layout/images/logoCompany.png';
        const companyLogo = this.invoiceData.bannerImage.length > 0 ? this.config.Server + 'assets/layout/images/companies/' + this.invoiceData.bannerImage[0].image : 'assets/layout/images/logoCompany.png';
        if(this.invoiceData.bannerImage.length > 0) {
            if(this.invoiceData.bannerImage.length === 1) {
                logoBlock = `
                    <div>
                        <img src="${companyLogo}"
                        alt="Company Logo" style="
                            display: block;
                            margin-left: auto;
                            margin-right: auto;
                            width: 58%;
                            margin-top: 3px;
                            margin-bottom: 2px;
                        " />
                    </div>
                `;
            }
            if(this.invoiceData.bannerImage.length === 2) {
                logoBlock = `
                    <div style="display: flex; justify-content: space-between;">
                        <img src="${companyLogo}"
                        alt="Company Logo" style="
                            display: block;
                            margin-left: auto;
                            margin-right: auto;
                            width: 49%;
                            margin-top: 3px;
                            margin-bottom: 2px;
                        " />
                        <img src="${this.config.Server + 'assets/layout/images/companies/' + this.invoiceData.bannerImage[1].image}"
                        alt="Company Logo" style="
                            display: block;
                            margin-left: auto;
                            margin-right: auto;
                            width: 49%;
                            margin-top: 3px;
                            margin-bottom: 2px;
                        " />
                    </div>
                `;
            }
        }
        else {
            logoBlock = `
                <div>
                    <img src="${companyLogo}"
                    alt="Company Logo" style="
                        display: block;
                        margin-left: auto;
                        margin-right: auto;
                        width: 58%;
                        margin-top: 3px;
                        margin-bottom: 2px;
                    " />
                </div>
            `;
        }
        if(this.invoiceData.contact.length == 1){
            contactBlock =`<div style="
                    text-align: center;
                    font-size: 11px;
                    line-height: 15px;
                    color: black;
                ">
                ${ printData.branchPhone }
                </div>
                `
        }
        else if (this.invoiceData.contact.length == 2){
            contactBlock =`
            <div style="
                    text-align: center;
                    font-size: 11px;
                    line-height: 15px;
                    color: black;
                ">
                ${ this.invoiceData.contact[0].contactNumber }
                </div>
            <div style="
                    text-align: center;
                    font-size: 11px;
                    line-height: 15px;
                    color: black;
                ">
                ${ this.invoiceData.contact[1].contactNumber }
                </div>
                `
        }


        let taxMessage = "";
        if(this.taxType === 'INCLUDING_TAX') {
            taxMessage = printData.taxOnFee + " " + this.setLabel("taxIncludedFeeLabel");
        }
        let grandTotal = 0;
        if(this.taxType == 'WITH_TAX') {
            grandTotal = ((printData.feeAmount - printData.discountOnFee) || 0) + (printData.taxOnFee || 0) ;
            this.fund.remainingBalance = printData.balance - grandTotal - printData.discountOnFee + printData.taxOnFee;
            this.fund.remainingBalance =  this.fund.remainingBalance * (1 + this.taxRate / 100);
        }
        else if(this.taxType != 'WITH_TAX') {
            grandTotal = printData.feeAmount - printData.discountOnFee;
            this.fund.remainingBalance = printData.balance - grandTotal - printData.discountOnFee;
        }
        if (this.fund.remainingBalance < 0) {
            this.fund.remainingBalance = 0;
        }
        let conditinalString = "";
        let conditionalStingTwo = "";

        if(this.branch.invoiceData.showAddedBy != undefined && this.branch.invoiceData.showAddedBy) {
            conditinalString = `
        <tr>
            <td style="
                    font-size: 10px;
                    text-align: left;
                    padding: 0 0 0 12px;
                    font-weight: bold;
                ">
                Added By:
            </td>
            <td style="
                    font-size: 10px;
                    text-align: center;
                    padding: 0px;
                ">
                ${user.name }
            </td>
        </tr>
        `;
        }
        if(this.branch.invoiceData.showCustomerContact != undefined && this.branch.invoiceData.showCustomerContact) {
            conditionalStingTwo = `
             <tr style="
                    border: 1px solid black;
                    font-size: 9px;
                    line-height: 12px;
                    margin-top: 8px;
                    margin-left: 8px;
                    width: 95%;
                ">
            <td style="
                    font-size: 10px;
                    text-align: left;
                    padding: 0 0 0 12px;
                    font-weight: bold;
                ">
                Cust ContactNo:
            </td>
            <td style="
                    font-size: 10px;
                    text-align: left;
                    padding: 0 0 0 30px;
                ">
                ${this.member.contactDetail?.contact || this.member.contact }
            </td>
        </tr>
        `;
        }
        let srbInvoiceBlock = "";

        if (this.srbInvoiceLines?.length > 1) {
            srbInvoiceBlock = `
            <div style="
                text-align: center;
                padding-top: 6px;
                font-size: 10px;
                font-weight: bold;
                color: black;
                max-width: 100%;
                padding-left: 2px;
                padding-right: 2px;
                box-sizing: border-box;
            ">
            ${this.srbInvoiceLines
              .map(
                (line) =>
                  `<div style="margin-top: 2px;word-break: break-all;overflow-wrap: anywhere;white-space: normal;">SRB-InvoiceID: ${line}</div>`,
              )
              .join('')}
            </div>
        `;
        } else if (this.srbInvoiceLines?.length === 1 || this.srbInvoiceId) {
            const singleId = this.srbInvoiceLines?.[0] || this.srbInvoiceId;
            srbInvoiceBlock = `
            <div style="
                text-align: center;
                padding-top: 6px;
                font-size: 10px;
                font-weight: bold;
                color: black;
                max-width: 100%;
                padding-left: 2px;
                padding-right: 2px;
                box-sizing: border-box;
                word-break: break-all;
                overflow-wrap: anywhere;
                white-space: normal;
            ">
            SRB-InvoiceID: ${singleId}
            </div>
        `;
        }
        const fbrIds = (this.fbrInvoiceLines?.length ? this.fbrInvoiceLines : (this.fbrInvoiceId ? [this.fbrInvoiceId] : []))
            .map((id) => String(id ?? '').trim())
            .filter((id) => id.length > 0);
        const fbrItems = await fbrQrItems(fbrIds);
        const fbrInvoiceBlock = fbrReceiptBlockHtml(
            fbrItems,
            fbrItems.length ? fbrDiLogoAbsoluteUrl() : '',
        );
        let popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(`
      <html>
      <head>
        <title>${title}</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            .heading td {
              font-size: 13px;
            }
            .item td {
                font-size: 13px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>
    <div class="invoice-box" style="
                padding: 0px !important;
                width: 75mm;
                max-width: 75mm;
                margin: 0 !important;
                ">
        <div style="width: 75mm; max-width: 75mm; margin-top: 30px; margin-bottom: 20px">
            ${logoBlock}
            <div style="
                    text-align: center;
                    font-size: 11px;
                    line-height: 14px;
                    color: black;
                ">
                ${ this.invoiceData.name }
            </div>
            <div style="
                    text-align: center;
                    font-size: 11px;
                    line-height: 14px;
                    color: black;
                ">
                ${ this.invoiceData.address }
            </div>
            ${contactBlock}
            <table style="
                    border: 1px solid black;
                    font-size: 9px;
                    line-height: 12px;
                    margin-top: 8px;
                    margin-left: 8px;
                    width: 95%;
                ">
                <tbody>
                    <tr>
                        <td style="
                                font-size: 10px;
                                text-align:center;
                                padding: 0px;
                                font-weight: bold;
                                padding-right:33px;
                            " colspan="2">
                            ${ printData.invoice }
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                                font-weight: bold;
                            ">
                            Created:
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: left;
                                padding: 0px;
                            ">
                            ${ date }
                        </td>

                    </tr>
                    <tr>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                                font-weight: bold;
                            ">
                            Due Date:
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: left;
                                padding: 0px;
                            ">
                            ${ invoicePeriodStartLabel }
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                                font-weight: bold;
                            ">
                            Next Due:
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: left;
                                padding: 0px;
                            ">
                            ${ invoicePeriodEndLabel }

                        </td>
                    </tr>
                </tbody>
            </table>

      <table style="
                    border: 1px solid black;
                    font-size: 9px;
                    line-height: 12px;
                    margin-top: 8px;
                    margin-left: 8px;
                    width: 95%;
                ">
                <tbody>
                                     ${conditinalString}

                       <tr>

                        <td style="
                                font-size: 10px;
                                text-align: left;
                                padding: 0px;
                                padding-left: 12px;
                                font-weight: bold;
                            ">
                            Package:
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                            ">
                            ${memberPackage }

                        </td>
                    </tr>
                </tbody>
            </table>
             <table style="${
            this.branch.invoiceData.showCustomerContact
                ? 'border: 1px solid black; font-size: 9px; line-height: 12px; margin-top: 8px; margin-left: 8px; width: 95%;'
                : 'display: none;'}">
                <tbody>
                    ${conditionalStingTwo}
                </tbody>
            </table>
            <table style="border-collapse: collapse;border: 1px solid black;font-size: 9px;line-height: 12px;margin-top: 8px;margin-left: 8px;width: 95%;">
                    <tbody>
                        <tr>
                            <td style="font-size: 10px;padding: 1px 1px 1px 12px;font-weight: bold; text-align:left;" colspan="1">
                                ${ this.setLabel("modeOfPaymentDropdownLabel") }

                            </td>
                            <td style="font-size: 10px;text-align: left;padding: 0 0 0 30px;" colspan="5">
                                ${paymentModeHeader}
                            </td>
                        </tr>
                    </tbody>
            </table>
            <table style="
                    border-collapse: collapse;
                    font-size: 12px;
                    font-size: 9px;
                    margin-top: 3px;
                    line-height: normal;
                    width: 95%;
                    margin-left: 8px;
                ">
                <thead style="
                        border: 1px solid black;
                        text-align: center;
                        font-weight: bold;
                        font-size: 12px;
                        font-size: 9px;
                        background-color: black;
                        color: white;
                        border: 1px solid black;
                    ">
                    <tr style="background-color: black; color: white">
                        <th style="
                                width: 40px;
                                word-break: break-word;
                                font-size: 10px;
                            ">
                            ${LabelLable}
                        </th>
                        <th style="
                                width: 40px;
                                word-break: break-word;
                                font-size: 10px;
                            ">
                            ${nameLabel}
                        </th>

                        <th style="
                                width: 40px;
                                word-break: break-word;
                                font-size: 10px;
                            ">
                            ${typeLabel}
                        </th>
                        <th style="width: 40px; font-size: 9px">${amountLabel}</th>
                    ${printData.discountOnFee > 0 ? `<th style="width: 40px; font-size: 9px">${discountLabel}</th>` : ''}
                        ${this.hasPrintTax() ? `<th style="width: 40px; font-size: 9px">${taxLabel}</th>` : ''}
                    </tr>
                </thead>
                <tbody>

                    <tr>
                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${ printData.memberTagNumber }
                        </td>
                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${ printData.memberName }
                        </td>
                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${ printData.feeStatus }
                        </td>
                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${ printData.feeAmount.toLocaleString() }
                        </td>
                        ${printData.discountOnFee > 0 ? `<td style="
                        font-size: 9px;
                        border: 1px solid black;
                        text-align: center;
                    ">
    ${ printData.discountOnFee.toLocaleString() }
</td>` : ''}
                        ${this.hasPrintTax() ? `<td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${ printData.taxOnFee.toLocaleString() }
                        </td>` : ''}
                    </tr>
                    ${paymentModeRowsHtml}
                    <tr>
                       <td style="
        font-size: 10px;
        text-align: center;
        font-weight: bold;
        border-bottom: 1px solid;
        border-left: 1px solid;
        text-align: left;
    " colspan="${this.getPrintSubtotalLabelColspan(printData.discountOnFee)}">
    ${subTotalLabel}
</td>
<td style="
        font-size: 10px;
        text-align: center;
        border-right: 1px solid;
        border-bottom: 1px solid;
        text-align: center;
    " colspan="${this.getPrintSubtotalValueColspan(printData.discountOnFee)}">
                            <span>
                                ${ grandTotal.toLocaleString() }
                            </span>
                            <i style="display: block; font-size: 12px;  color: blue;">
                                ${taxMessage}
                            </i>
                        </td>
                    </tr>
                    <tr>
                       <td style="
        font-size: 10px;
        text-align: center;
        font-weight: bold;
        border-bottom: 1px solid;
        border-left: 1px solid;
            text-align: left;
    " colspan="${this.getPrintSubtotalLabelColspan(printData.discountOnFee)}">
    ${balanceRemainingLabel}
</td>
<td style="
        font-size: 10px;
        text-align: center;
        border-right: 1px solid;
        border-bottom: 1px solid;
        text-align: center;
    " colspan="${this.getPrintSubtotalValueColspan(printData.discountOnFee)}">
                            <span>
                            ${ this.fund.remainingBalance.toLocaleString() }
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div
                style="text-align: center;
                padding-top: 10px;
                font-size: 10px;
                line-height:18px;
                font-family:'Times New Roman';
                color:  black;
                white-space: wrap;">
                ${this.invoiceMessage}
            </div>
            ${srbInvoiceBlock}
            ${fbrInvoiceBlock}
            <div style="
                    text-align: center;
                    padding-top: 6px;
                    font-size: 10px;
                    font-weight: bold;
                    color: black;
                    white-space: nowrap;
                ">
                ${softwareProvidedByTecfolkLabel}
            </div>
        </div>
    </div>
    </body>
    </html>
    `);
    // this.onBeforeDialogHide();
    this.dialogVisibility = false;
    }

    printGroupInvoice(data): void {
        const nameLabel = this.setLabel("nameLabel");
        const typeLabel = this.setLabel("typeLabel");
        const amountLabel = this.setLabel("amountLabel");
        const discountLabel = this.setLabel("discountLabel");
        const taxLabel = this.setLabel("taxLabel");
        const balanceRemainingLabel = this.setLabel("balanceRemainingLabel");
        const subTotalLabel = this.setLabel("subTotalLabel");
        const softwareProvidedByTecfolkLabel = this.setLabel("softwareProvidedByTecfolkLabel");
        const LabelLable = this.setLabel("m#Label");
        const currentDate=new Date();
        const title = this.branch.name+ " " + currentDate.getDate()+ "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
        let allReceptData = "";
        for (let i = 0; i < data.length; i++) {
            const printData = data[i];
        const date = new Date(printData.date).toLocaleDateString();
        const { periodStartLabel, periodEndLabel } = this.getPrintInvoicePeriodLabels(printData);
        const companyLogo = printData.companyLogo ? this.config.Server + 'assets/layout/images/companies/' + printData.companyLogo : 'assets/layout/images/logoCompany.png';
        let taxMessage = "";
        if(this.taxType === 'INCLUDING_TAX') {
            taxMessage = printData.taxOnFee + " " + this.setLabel("taxIncludedFeeLabel");
        }
        let grandTotal = 0;
        if(this.taxType == 'WITH_TAX') {
            grandTotal = ((printData.feeAmount - printData.discountOnFee) || 0) + (printData.taxOnFee || 0);
            this.fund.remainingBalance = ((printData.balance - grandTotal) - printData.discountOnFee) + printData.taxOnFee;
            this.fund.remainingBalance =  this.fund.remainingBalance * (1 + this.taxRate / 100);
        }
        else if(this.taxType != 'WITH_TAX') {
            grandTotal = printData.feeAmount - printData.discountOnFee;
            this.fund.remainingBalance = (printData.balance - grandTotal) - printData.discountOnFee;
        }
        if (this.fund.remainingBalance < 0) {
            this.fund.remainingBalance = 0;
        }
        let singleRecept = `
      <div class="invoice-box" style="
                  padding: 0px !important;
                  width: 75mm;
                  max-width: 75mm;
                  margin: 0 !important;
                  ">
          <div style="width: 75mm; max-width: 75mm; margin-top: 30px; margin-bottom: 30px">
              <img src="${companyLogo}"
                  alt="Company Logo" style="
                      display: block;
                      margin-left: auto;
                      margin-right: auto;
                      width: 58%;
                      margin-top: 3px;
                      margin-bottom: 2px;
                  " />
              <div style="
                      text-align: center;
                      font-size: 11px;
                      line-height: 14px;
                      color: black;
                  ">
                  ${ printData.branchName }
              </div>
              <div style="
                      text-align: center;
                      font-size: 11px;
                      line-height: 14px;
                      color: black;
                  ">
                  ${ printData.branchAddress }
              </div>
              <div style="
                      text-align: center;
                      font-size: 11px;
                      line-height: 15px;
                      color: black;
                  ">
                  ${ printData.branchPhone }
              </div>
              <table style="
                      border-collapse: collapse;
                      border: 1px solid black;
                      font-size: 9px;
                      line-height: 12px;
                      margin-top: 8px;
                      margin-left: 8px;
                      width: 95%;
                  ">
                  <tbody>
                      <tr>
                          <td style="
                                  font-size: 10px;
                                  text-align:center;
                                  padding: 0px;
                                  font-weight: bold;

                              " colspan="2">

                              ${ printData.invoice }
                          </td>
                          <td style="
                                  font-size: 10px;
                                  text-align: center;
                                  padding: 0px;
                                  font-weight: bold;
                              ">
                              Created:
                          </td>
                          <td style="
                                  font-size: 10px;
                                  text-align: center;
                                  padding: 0px;
                              ">
                              ${ date }
                          </td>

                      </tr>
                      <tr>
                          <td style="
                                  font-size: 10px;
                                  text-align: center;
                                  padding: 0px;
                                  font-weight: bold;
                              ">
                              Due Date:
                          </td>
                          <td style="
                                  font-size: 10px;
                                  text-align: center;
                                  padding: 0px;
                              ">
                              ${ periodStartLabel }
                          </td>
                          <td style="
                                  font-size: 10px;
                                  text-align: center;
                                  padding: 0px;
                                  font-weight: bold;
                              ">
                              Next Due:
                          </td>
                          <td style="
                                  font-size: 10px;
                                  text-align: center;
                                  padding: 0px;
                              ">
                              ${ periodEndLabel }

                          </td>
                      </tr>
                  </tbody>
              </table>

              <table style="
                      border-collapse: collapse;
                      font-size: 12px;
                      font-size: 9px;
                      margin-top: 3px;
                      line-height: normal;
                      width: 95%;
                      margin-left: 8px;
                  ">
                  <thead style="
                          border: 1px solid black;
                          text-align: center;
                          font-weight: bold;
                          font-size: 12px;
                          font-size: 9px;
                          background-color: black;
                          color: white;
                          border: 1px solid black;
                      ">
                      <tr style="background-color: black; color: white">
                          <th style="
                                  width: 40px;
                                  word-break: break-word;
                                  font-size: 10px;
                              ">
                              ${LabelLable}
                          </th>
                          <th style="
                                  width: 40px;
                                  word-break: break-word;
                                  font-size: 10px;
                              ">
                              ${nameLabel}
                          </th>

                          <th style="
                                  width: 40px;
                                  word-break: break-word;
                                  font-size: 10px;
                              ">
                              ${typeLabel}
                          </th>
                          <th style="width: 40px; font-size: 9px">${amountLabel}</th>
                             ${printData.discountOnFee > 0 ? `<th style="width: 40px; font-size: 9px">${discountLabel}</th>` : ''}
                          ${this.hasPrintTax() ? `<th style="width: 40px; font-size: 9px">${taxLabel}</th>` : ''}
                      </tr>
                  </thead>
                  <tbody>

                      <tr>
                          <td style="
                                  font-size: 9px;
                                  border: 1px solid black;
                                  text-align: center;
                              ">
                              ${ printData.memberTagNumber }
                          </td>
                          <td style="
                                  font-size: 9px;
                                  border: 1px solid black;
                                  text-align: center;
                              ">
                              ${ printData.memberName }
                          </td>
                          <td style="
                                  font-size: 9px;
                                  border: 1px solid black;
                                  text-align: center;
                              ">
                              ${ printData.feeStatus }
                          </td>
                          <td style="
                                  font-size: 9px;
                                  border: 1px solid black;
                                  text-align: center;
                              ">
                              ${ printData.feeAmount.toLocaleString()  }
                          </td>
                          ${printData.discountOnFee > 0 ? `<td style="
                        font-size: 9px;
                        border: 1px solid black;
                        text-align: center;
                    ">
    ${ printData.discountOnFee.toLocaleString() }
</td>` : ''}
                          ${this.hasPrintTax() ? `<td style="
                                  font-size: 9px;
                                  border: 1px solid black;
                                  text-align: center;
                              ">
                              ${ printData.taxOnFee.toLocaleString() }
                          </td>` : ''}
                      </tr>
                      <tr>
                          <td></td>
                          <td style="
        font-size: 10px;
        text-align: center;
        font-weight: bold;
        border-bottom: 1px solid;
        border-left: 1px solid;
    " colspan="${this.getPrintMonthlySubtotalLabelColspan(printData.discountOnFee)}">
    ${subTotalLabel}
</td>
<td style="
        font-size: 10px;
        text-align: center;
        border-right: 1px solid;
        border-bottom: 1px solid;
    " colspan="${this.getPrintSubtotalValueColspan(printData.discountOnFee)}">
                              <span>
                                  ${ grandTotal.toLocaleString()}
                              </span>
                              <i style="display: block; font-size: 12px;  color: blue;">
                                  ${taxMessage}
                              </i>
                          </td>
                      </tr>
                      <tr>
                          <td></td>
                          <td style="
        font-size: 10px;
        text-align: center;
        font-weight: bold;
        border-bottom: 1px solid;
        border-left: 1px solid;
    " colspan="${this.getPrintMonthlySubtotalLabelColspan(printData.discountOnFee)}">
    ${balanceRemainingLabel}
</td>
<td style="
        font-size: 10px;
        text-align: center;
        border-right: 1px solid;
        border-bottom: 1px solid;
    " colspan="${this.getPrintSubtotalValueColspan(printData.discountOnFee)}">
                              <span>
                                ${ this.fund.remainingBalance.toLocaleString()}
                              </span>
                          </td>
                      </tr>
                  </tbody>
              </table>
                <div
                    style="text-align: center;
                    padding-top: 10px;
                    font-size: 10px;
                    font-family:'Times New Roman';
                    color:  black;
                    white-space: wrap;">
                    ${this.invoiceMessage}
                </div>
              <div style="
                      text-align: center;
                      padding-top: 6px;
                      font-size: 10px;
                      font-weight: bold;
                      color: black;
                      white-space: nowrap;
                  ">
                  ${softwareProvidedByTecfolkLabel}
              </div>
          </div>
      </div>
      `;
      allReceptData += singleRecept;
        }
        let reciptHtml = `
        <html>
        <head>
          <title>${title}</title>
          <style>
              .invoice-box {
                  max-width: 800px;
                  margin: auto;
                  padding: 30px;
                  border: 1px solid #eee;
                  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                  font-size: 16px;
                  line-height: 24px;
                  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                  color: #555;
              }

              .invoice-box table {
                  width: 100%;
                  line-height: inherit;
                  text-align: left;
              }

              .invoice-box table td {
                  padding: 5px;
                  vertical-align: top;
              }

              .invoice-box table tr td:nth-child(n + 2) {
                  text-align: right;
              }

              .invoice-box table tr.top table td.title {
                  font-size: 45px;
                  line-height: 45px;
                  color: #333;
              }

              .invoice-box table tr.heading td {
                  background: #eee;
                  border-bottom: 1px solid #ddd;
                  font-weight: bold;
              }

              .invoice-box table tr.details td {
                  padding-bottom: 20px;
              }

              .invoice-box table tr.item td {
                  border-bottom: 1px solid #eee;
              }
              .invoice-box table tr.item.last td {
                  border-bottom: none;
              }
              .invoice-box table tr.item input {
                  padding-left: 5px;
              }
              .invoice-box table tr.item td:first-child input {
                  margin-left: -5px;
                  width: 100%;
              }
              .invoice-box table tr.total td:nth-child(2) {
                  border-top: 2px solid #eee;
                  font-weight: bold;
              }
              .invoice-box input[type="number"] {
                  width: 60px;
              }
              .heading td {
                font-size: 13px;
              }
              .item td {
                  font-size: 13px;
              }
              @media only screen and (max-width: 600px) {
                  .invoice-box table tr.top table td {
                      width: 100%;
                      display: block;
                      text-align: center;
                  }

                  .invoice-box table tr.information table td {
                      width: 100%;
                      display: block;
                      text-align: center;
                  }
              }
              .rtl {
                  direction: rtl;
                  font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                      sans-serif;
              }
              .rtl table {
                  text-align: right;
              }
              .rtl table tr td:nth-child(2) {
                  text-align: left;
              }
          </style>
      </head>
      <body>
      ${allReceptData}
      </body>
      </html>
      `;
        let popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(reciptHtml);
        this.dialogVisibility = false;
    }
    onBeforeDialogHide() {
        if (this.isFeeSubmitting) {
            return;
        }
        this.resetSplitState();
        this.closeFeeCollectionDialog.emit();
    }



}
